export let defaultReceiptTemplate = `

    <%#  {"versionInfo":{"buildMinVersion":12,"buildMaxVersion":999,"name":"DEFAULT THEME"},"additionalProperties":{}, "dynamicFormDataType": []} %>
        <% 
            const countries = [
                {
                    "code": "AF",
                    "name": "AFGHANISTAN",
                    "currency": {
                        "currencyName": "AFGHANISTAN AFGHANI",
                        "currencyCode": "AFN",
                        "currencySymbol": "؋"
                    },
                    "geo": {
                        "latitude": 33.93911,
                        "longitude": 67.709953
                    },
                    "capital": "KABUL",
                    "phone": "93"
                },
                {
                    "code": "AL",
                    "name": "ALBANIA",
                    "currency": {
                        "currencyName": "ALBANIAN LEK",
                        "currencyCode": "ALL",
                        "currencySymbol": "lekë"
                    },
                    "geo": {
                        "latitude": 41.153332,
                        "longitude": 20.168331
                    },
                    "capital": "TIRANA",
                    "phone": "355"
                },
                {
                    "code": "DZ",
                    "name": "ALGERIA",
                    "currency": {
                        "currencyName": "ALGERIAN DINAR",
                        "currencyCode": "DZD",
                        "currencySymbol": "د.ج"
                    },
                    "geo": {
                        "latitude": 28.033886,
                        "longitude": 1.659626
                    },
                    "capital": "ALGIERS",
                    "phone": "213"
                },
                {
                    "code": "AS",
                    "name": "AMERICAN SAMOA",
                    "currency": {
                        "currencyName": "US DOLLAR",
                        "currencyCode": "USD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -14.270972,
                        "longitude": -170.132217
                    },
                    "capital": "PAGO PAGO",
                    "phone": "684"
                },
                {
                    "code": "AD",
                    "name": "ANDORRA",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 42.546245,
                        "longitude": 1.601554
                    },
                    "capital": "ANDORRA",
                    "phone": "376"
                },
                {
                    "code": "AO",
                    "name": "ANGOLA",
                    "currency": {
                        "currencyName": "ANGOLAN KWANZA",
                        "currencyCode": "AOA",
                        "currencySymbol": "Kz"
                    },
                    "geo": {
                        "latitude": -11.202692,
                        "longitude": 17.873887
                    },
                    "capital": "LUANDA",
                    "phone": "244"
                },
                {
                    "code": "AI",
                    "name": "ANGUILLA",
                    "currency": {
                        "currencyName": "EAST CARIBBEAN DOLLAR",
                        "currencyCode": "XCD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 18.220554,
                        "longitude": -63.068615
                    },
                    "capital": "THE VALLEY",
                    "phone": "1-264"
                },
                {
                    "code": "AQ",
                    "name": "ANTARCTICA",
                    "currency": {
                        "currencyName": "EAST CARIBBEAN DOLLAR",
                        "currencyCode": "XCD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -75.250973,
                        "longitude": -0.071389
                    },
                    "capital": "",
                    "phone": "672"
                },
                {
                    "code": "AG",
                    "name": "ANTIGUA AND BARBUDA",
                    "currency": {
                        "currencyName": "EAST CARIBBEAN DOLLAR",
                        "currencyCode": "XCD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 17.060816,
                        "longitude": -61.796428
                    },
                    "capital": "ST. JOHNS",
                    "phone": "1-268"
                },
                {
                    "code": "AR",
                    "name": "ARGENTINA",
                    "currency": {
                        "currencyName": "ARGENTINE PESO",
                        "currencyCode": "ARS",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -38.416097,
                        "longitude": -63.616672
                    },
                    "capital": "BUENOS AIRES",
                    "phone": "54"
                },
                {
                    "code": "AM",
                    "name": "ARMENIA",
                    "currency": {
                        "currencyName": "ARMENIAN DRAM",
                        "currencyCode": "AMD",
                        "currencySymbol": "դր."
                    },
                    "geo": {
                        "latitude": 40.069099,
                        "longitude": 45.038189
                    },
                    "capital": "YEREVAN",
                    "phone": "374"
                },
                {
                    "code": "AW",
                    "name": "ARUBA",
                    "currency": {
                        "currencyName": "ARUBAN GUILDER",
                        "currencyCode": "AWG",
                        "currencySymbol": "ƒ"
                    },
                    "geo": {
                        "latitude": 12.52111,
                        "longitude": -69.968338
                    },
                    "capital": "ORANJESTAD",
                    "phone": "297"
                },
                {
                    "code": "AU",
                    "name": "AUSTRALIA",
                    "currency": {
                        "currencyName": "AUSTRALIAN DOLLAR",
                        "currencyCode": "AUD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -25.274398,
                        "longitude": 133.775136
                    },
                    "capital": "CANBERRA",
                    "phone": "61"
                },
                {
                    "code": "AT",
                    "name": "AUSTRIA",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 47.516231,
                        "longitude": 14.550072
                    },
                    "capital": "VIENNA",
                    "phone": "43"
                },
                {
                    "code": "AZ",
                    "name": "AZERBAIJAN",
                    "currency": {
                        "currencyName": "AZERBAIJAN NEW MANAT",
                        "currencyCode": "AZN",
                        "currencySymbol": "₼"
                    },
                    "geo": {
                        "latitude": 40.143105,
                        "longitude": 47.576927
                    },
                    "capital": "BAKU",
                    "phone": "994"
                },
                {
                    "code": "BS",
                    "name": "BAHAMAS",
                    "currency": {
                        "currencyName": "BAHAMIAN DOLLAR",
                        "currencyCode": "BSD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 25.03428,
                        "longitude": -77.39628
                    },
                    "capital": "NASSAU",
                    "phone": "1-242"
                },
                {
                    "code": "BH",
                    "name": "BAHRAIN",
                    "currency": {
                        "currencyName": "BAHRAINI DINAR",
                        "currencyCode": "BHD",
                        "currencySymbol": ".د.ب"
                    },
                    "geo": {
                        "latitude": 25.930414,
                        "longitude": 50.637772
                    },
                    "capital": "AL-MANAMAH",
                    "phone": "973"
                },
                {
                    "code": "BD",
                    "name": "BANGLADESH",
                    "currency": {
                        "currencyName": "BANGLADESHI TAKA",
                        "currencyCode": "BDT",
                        "currencySymbol": "৳"
                    },
                    "geo": {
                        "latitude": 23.684994,
                        "longitude": 90.356331
                    },
                    "capital": "DHAKA",
                    "phone": "880"
                },
                {
                    "code": "BB",
                    "name": "BARBADOS",
                    "currency": {
                        "currencyName": "BARBADOS DOLLAR",
                        "currencyCode": "BBD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 13.193887,
                        "longitude": -59.543198
                    },
                    "capital": "BRIDGETOWN",
                    "phone": "1-246"
                },
                {
                    "code": "BY",
                    "name": "BELARUS",
                    "currency": {
                        "currencyName": "BELARUSSIAN RUBLE",
                        "currencyCode": "BYR",
                        "currencySymbol": "p."
                    },
                    "geo": {
                        "latitude": 53.709807,
                        "longitude": 27.953389
                    },
                    "capital": "MINSK",
                    "phone": "375"
                },
                {
                    "code": "BE",
                    "name": "BELGIUM",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 50.503887,
                        "longitude": 4.469936
                    },
                    "capital": "BRUSSELS",
                    "phone": "32"
                },
                {
                    "code": "BZ",
                    "name": "BELIZE",
                    "currency": {
                        "currencyName": "BELIZE DOLLAR",
                        "currencyCode": "BZD",
                        "currencySymbol": "BZ$"
                    },
                    "geo": {
                        "latitude": 17.189877,
                        "longitude": -88.49765
                    },
                    "capital": "BELMOPAN",
                    "phone": "501"
                },
                {
                    "code": "BJ",
                    "name": "BENIN",
                    "currency": {
                        "currencyName": "CFA FRANC BCEAO",
                        "currencyCode": "XOF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": 9.30769,
                        "longitude": 2.315834
                    },
                    "capital": "PORTO-NOVO",
                    "phone": "229"
                },
                {
                    "code": "BM",
                    "name": "BERMUDA",
                    "currency": {
                        "currencyName": "BERMUDIAN DOLLAR",
                        "currencyCode": "BMD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 32.321384,
                        "longitude": -64.75737
                    },
                    "capital": "HAMILTON",
                    "phone": "1-441"
                },
                {
                    "code": "BT",
                    "name": "BHUTAN",
                    "currency": {
                        "currencyName": "BHUTAN NGULTRUM",
                        "currencyCode": "BTN",
                        "currencySymbol": "Nu."
                    },
                    "geo": {
                        "latitude": 27.514162,
                        "longitude": 90.433601
                    },
                    "capital": "THIMPHU",
                    "phone": "975"
                },
                {
                    "code": "BO",
                    "name": "BOLIVIA",
                    "currency": {
                        "currencyName": "BOLIVIANO",
                        "currencyCode": "BOB",
                        "currencySymbol": "Bs."
                    },
                    "geo": {
                        "latitude": -16.290154,
                        "longitude": -63.588653
                    },
                    "capital": "LA PAZ",
                    "phone": "591"
                },
                {
                    "code": "BA",
                    "name": "BOSNIA-HERZEGOVINA",
                    "currency": {
                        "currencyName": "MARKA",
                        "currencyCode": "BAM",
                        "currencySymbol": "KM"
                    },
                    "geo": {
                        "latitude": 43.915886,
                        "longitude": 17.679076
                    },
                    "capital": "SARAJEVO",
                    "phone": "387"
                },
                {
                    "code": "BW",
                    "name": "BOTSWANA",
                    "currency": {
                        "currencyName": "BOTSWANA PULA",
                        "currencyCode": "BWP",
                        "currencySymbol": "P"
                    },
                    "geo": {
                        "latitude": -22.328474,
                        "longitude": 24.684866
                    },
                    "capital": "GABORONE",
                    "phone": "267"
                },
                {
                    "code": "BV",
                    "name": "BOUVET ISLAND",
                    "currency": {
                        "currencyName": "NORWEGIAN KRONE",
                        "currencyCode": "NOK",
                        "currencySymbol": "kr"
                    },
                    "geo": {
                        "latitude": -54.423199,
                        "longitude": 3.413194
                    },
                    "capital": "",
                    "phone": "0047"
                },
                {
                    "code": "BR",
                    "name": "BRAZIL",
                    "currency": {
                        "currencyName": "BRAZILIAN REAL",
                        "currencyCode": "BRL",
                        "currencySymbol": "R$"
                    },
                    "geo": {
                        "latitude": -14.235004,
                        "longitude": -51.92528
                    },
                    "capital": "BRASILIA",
                    "phone": "55"
                },
                {
                    "code": "IO",
                    "name": "BRITISH INDIAN OCEAN TERRITORY",
                    "currency": {
                        "currencyName": "US DOLLAR",
                        "currencyCode": "USD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -6.343194,
                        "longitude": 71.876519
                    },
                    "capital": "",
                    "phone": "00246"
                },
                {
                    "code": "BN",
                    "name": "BRUNEI DARUSSALAM",
                    "currency": {
                        "currencyName": "BRUNEI DOLLAR",
                        "currencyCode": "BND",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 4.535277,
                        "longitude": 114.727669
                    },
                    "capital": "BANDAR SERI BEGAWAN",
                    "phone": "673"
                },
                {
                    "code": "BG",
                    "name": "BULGARIA",
                    "currency": {
                        "currencyName": "BULGARIAN LEV",
                        "currencyCode": "BGN",
                        "currencySymbol": "лв"
                    },
                    "geo": {
                        "latitude": 42.733883,
                        "longitude": 25.48583
                    },
                    "capital": "SOFIA",
                    "phone": "359"
                },
                {
                    "code": "BF",
                    "name": "BURKINA FASO",
                    "currency": {
                        "currencyName": "CFA FRANC BCEAO",
                        "currencyCode": "XOF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": 12.238333,
                        "longitude": -1.561593
                    },
                    "capital": "OUAGADOUGOU",
                    "phone": "226"
                },
                {
                    "code": "BI",
                    "name": "BURUNDI",
                    "currency": {
                        "currencyName": "BURUNDI FRANC",
                        "currencyCode": "BIF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": -3.373056,
                        "longitude": 29.918886
                    },
                    "capital": "BUJUMBURA",
                    "phone": "257"
                },
                {
                    "code": "KH",
                    "name": "CAMBODIA",
                    "currency": {
                        "currencyName": "KAMPUCHEAN RIEL",
                        "currencyCode": "KHR",
                        "currencySymbol": "៛"
                    },
                    "geo": {
                        "latitude": 12.565679,
                        "longitude": 104.990963
                    },
                    "capital": "PHNOM PENH",
                    "phone": "855"
                },
                {
                    "code": "CM",
                    "name": "CAMEROON",
                    "currency": {
                        "currencyName": "CFA FRANC BEAC",
                        "currencyCode": "XAF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": 7.369722,
                        "longitude": 12.354722
                    },
                    "capital": "YAOUNDE",
                    "phone": "237"
                },
                {
                    "code": "CA",
                    "name": "CANADA",
                    "currency": {
                        "currencyName": "CANADIAN DOLLAR",
                        "currencyCode": "CAD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 56.130366,
                        "longitude": -106.346771
                    },
                    "capital": "OTTAWA",
                    "phone": "1"
                },
                {
                    "code": "CV",
                    "name": "CAPE VERDE",
                    "currency": {
                        "currencyName": "CAPE VERDE ESCUDO",
                        "currencyCode": "CVE",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 16.002082,
                        "longitude": -24.013197
                    },
                    "capital": "PRAIA",
                    "phone": "238"
                },
                {
                    "code": "KY",
                    "name": "CAYMAN ISLANDS",
                    "currency": {
                        "currencyName": "CAYMAN ISLANDS DOLLAR",
                        "currencyCode": "KYD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 19.513469,
                        "longitude": -80.566956
                    },
                    "capital": "GEORGETOWN",
                    "phone": "1-345"
                },
                {
                    "code": "CF",
                    "name": "CENTRAL AFRICAN REPUBLIC",
                    "currency": {
                        "currencyName": "CFA FRANC BEAC",
                        "currencyCode": "XAF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": 6.611111,
                        "longitude": 20.939444
                    },
                    "capital": "BANGUI",
                    "phone": "236"
                },
                {
                    "code": "TD",
                    "name": "CHAD",
                    "currency": {
                        "currencyName": "CFA FRANC BEAC",
                        "currencyCode": "XAF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": 15.454166,
                        "longitude": 18.732207
                    },
                    "capital": "N'DJAMENA",
                    "phone": "235"
                },
                {
                    "code": "CL",
                    "name": "CHILE",
                    "currency": {
                        "currencyName": "CHILEAN PESO",
                        "currencyCode": "CLP",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -35.675147,
                        "longitude": -71.542969
                    },
                    "capital": "SANTIAGO",
                    "phone": "56"
                },
                {
                    "code": "CN",
                    "name": "CHINA",
                    "currency": {
                        "currencyName": "YUAN RENMINBI",
                        "currencyCode": "CNY",
                        "currencySymbol": "¥"
                    },
                    "geo": {
                        "latitude": 35.86166,
                        "longitude": 104.195397
                    },
                    "capital": "BEIJING",
                    "phone": "86"
                },
                {
                    "code": "CX",
                    "name": "CHRISTMAS ISLAND",
                    "currency": {
                        "currencyName": "AUSTRALIAN DOLLAR",
                        "currencyCode": "AUD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -10.447525,
                        "longitude": 105.690449
                    },
                    "capital": "THE SETTLEMENT",
                    "phone": "61"
                },
                {
                    "code": "CC",
                    "name": "COCOS (KEELING) ISLANDS",
                    "currency": {
                        "currencyName": "AUSTRALIAN DOLLAR",
                        "currencyCode": "AUD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -12.164165,
                        "longitude": 96.870956
                    },
                    "capital": "WEST ISLAND",
                    "phone": "61"
                },
                {
                    "code": "CO",
                    "name": "COLOMBIA",
                    "currency": {
                        "currencyName": "COLOMBIAN PESO",
                        "currencyCode": "COP",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 4.570868,
                        "longitude": -74.297333
                    },
                    "capital": "BOGOTA",
                    "phone": "57"
                },
                {
                    "code": "KM",
                    "name": "COMOROS",
                    "currency": {
                        "currencyName": "COMOROS FRANC",
                        "currencyCode": "KMF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": -11.875001,
                        "longitude": 43.872219
                    },
                    "capital": "MORONI",
                    "phone": "269"
                },
                {
                    "code": "CG",
                    "name": "CONGO",
                    "currency": {
                        "currencyName": "CFA FRANC BEAC",
                        "currencyCode": "XAF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": -0.228021,
                        "longitude": 15.827659
                    },
                    "capital": "BRAZZAVILLE",
                    "phone": "242"
                },
                {
                    "code": "CD",
                    "name": "CONGO, DEM. REPUBLIC",
                    "currency": {
                        "currencyName": "FRANCS",
                        "currencyCode": "CDF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": -4.038333,
                        "longitude": 21.758664
                    },
                    "capital": "KINSHASA",
                    "phone": "243"
                },
                {
                    "code": "CK",
                    "name": "COOK ISLANDS",
                    "currency": {
                        "currencyName": "NEW ZEALAND DOLLAR",
                        "currencyCode": "NZD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -21.236736,
                        "longitude": -159.777671
                    },
                    "capital": "AVARUA",
                    "phone": "682"
                },
                {
                    "code": "CR",
                    "name": "COSTA RICA",
                    "currency": {
                        "currencyName": "COSTA RICAN COLON",
                        "currencyCode": "CRC",
                        "currencySymbol": "₡"
                    },
                    "geo": {
                        "latitude": 9.748917,
                        "longitude": -83.753428
                    },
                    "capital": "SAN JOSE",
                    "phone": "506"
                },
                {
                    "code": "HR",
                    "name": "CROATIA",
                    "currency": {
                        "currencyName": "CROATIAN KUNA",
                        "currencyCode": "HRK",
                        "currencySymbol": "kn"
                    },
                    "geo": {
                        "latitude": 45.1,
                        "longitude": 15.2
                    },
                    "capital": "ZAGREB",
                    "phone": "385"
                },
                {
                    "code": "CU",
                    "name": "CUBA",
                    "currency": {
                        "currencyName": "CUBAN PESO",
                        "currencyCode": "CUP",
                        "currencySymbol": "₱"
                    },
                    "geo": {
                        "latitude": 21.521757,
                        "longitude": -77.781167
                    },
                    "capital": "HAVANA",
                    "phone": "53"
                },
                {
                    "code": "CY",
                    "name": "CYPRUS",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 35.126413,
                        "longitude": 33.429859
                    },
                    "capital": "NICOSIA",
                    "phone": "357"
                },
                {
                    "code": "CZ",
                    "name": "CZECH REP.",
                    "currency": {
                        "currencyName": "CZECH KORUNA",
                        "currencyCode": "CZK",
                        "currencySymbol": "Kč"
                    },
                    "geo": {
                        "latitude": 49.817492,
                        "longitude": 15.472962
                    },
                    "capital": "PRAGUE",
                    "phone": "420"
                },
                {
                    "code": "DK",
                    "name": "DENMARK",
                    "currency": {
                        "currencyName": "DANISH KRONE",
                        "currencyCode": "DKK",
                        "currencySymbol": "kr"
                    },
                    "geo": {
                        "latitude": 56.26392,
                        "longitude": 9.501785
                    },
                    "capital": "COPENHAGEN",
                    "phone": "45"
                },
                {
                    "code": "DJ",
                    "name": "DJIBOUTI",
                    "currency": {
                        "currencyName": "DJIBOUTI FRANC",
                        "currencyCode": "DJF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": 11.825138,
                        "longitude": 42.590275
                    },
                    "capital": "DJIBOUTI",
                    "phone": "253"
                },
                {
                    "code": "DM",
                    "name": "DOMINICA",
                    "currency": {
                        "currencyName": "EAST CARIBBEAN DOLLAR",
                        "currencyCode": "XCD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 15.414999,
                        "longitude": -61.370976
                    },
                    "capital": "ROSEAU",
                    "phone": "1-767"
                },
                {
                    "code": "DO",
                    "name": "DOMINICAN REPUBLIC",
                    "currency": {
                        "currencyName": "DOMINICAN PESO",
                        "currencyCode": "DOP",
                        "currencySymbol": "RD$"
                    },
                    "geo": {
                        "latitude": 18.735693,
                        "longitude": -70.162651
                    },
                    "capital": "SANTO DOMINGO",
                    "phone": "809"
                },
                {
                    "code": "EC",
                    "name": "ECUADOR",
                    "currency": {
                        "currencyName": "ECUADOR SUCRE",
                        "currencyCode": "ECS",
                        "currencySymbol": "S/."
                    },
                    "geo": {
                        "latitude": -1.831239,
                        "longitude": -78.183406
                    },
                    "capital": "QUITO",
                    "phone": "593"
                },
                {
                    "code": "EG",
                    "name": "EGYPT",
                    "currency": {
                        "currencyName": "EGYPTIAN POUND",
                        "currencyCode": "EGP",
                        "currencySymbol": "£"
                    },
                    "geo": {
                        "latitude": 26.820553,
                        "longitude": 30.802498
                    },
                    "capital": "CAIRO",
                    "phone": "20"
                },
                {
                    "code": "SV",
                    "name": "EL SALVADOR",
                    "currency": {
                        "currencyName": "EL SALVADOR COLON",
                        "currencyCode": "SVC",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 13.794185,
                        "longitude": -88.89653
                    },
                    "capital": "SAN SALVADOR",
                    "phone": "503"
                },
                {
                    "code": "GQ",
                    "name": "EQUATORIAL GUINEA",
                    "currency": {
                        "currencyName": "CFA FRANC BEAC",
                        "currencyCode": "XAF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": 1.650801,
                        "longitude": 10.267895
                    },
                    "capital": "MALABO",
                    "phone": "240"
                },
                {
                    "code": "ER",
                    "name": "ERITREA",
                    "currency": {
                        "currencyName": "ERITREAN NAKFA",
                        "currencyCode": "ERN",
                        "currencySymbol": "Nfk"
                    },
                    "geo": {
                        "latitude": 15.179384,
                        "longitude": 39.782334
                    },
                    "capital": "ASMARA",
                    "phone": "291"
                },
                {
                    "code": "EE",
                    "name": "ESTONIA",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 58.595272,
                        "longitude": 25.013607
                    },
                    "capital": "TALLINN",
                    "phone": "372"
                },
                {
                    "code": "ET",
                    "name": "ETHIOPIA",
                    "currency": {
                        "currencyName": "ETHIOPIAN BIRR",
                        "currencyCode": "ETB",
                        "currencySymbol": "Br"
                    },
                    "geo": {
                        "latitude": 9.145,
                        "longitude": 40.489673
                    },
                    "capital": "ADDIS ABABA",
                    "phone": "251"
                },
                {
                    "code": "EU.INT",
                    "name": "EUROPEAN UNION",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 9.0485,
                        "longitude": 7.4728
                    },
                    "capital": "BRUSSELS",
                    "phone": "0032"
                },
                {
                    "code": "FK",
                    "name": "FALKLAND ISLANDS (MALVINAS)",
                    "currency": {
                        "currencyName": "FALKLAND ISLANDS POUND",
                        "currencyCode": "FKP",
                        "currencySymbol": "£"
                    },
                    "geo": {
                        "latitude": -51.796253,
                        "longitude": -59.523613
                    },
                    "capital": "STANLEY",
                    "phone": "500"
                },
                {
                    "code": "FO",
                    "name": "FAROE ISLANDS",
                    "currency": {
                        "currencyName": "DANISH KRONE",
                        "currencyCode": "DKK",
                        "currencySymbol": "kr"
                    },
                    "geo": {
                        "latitude": 61.892635,
                        "longitude": -6.911806
                    },
                    "capital": "TORSHAVN",
                    "phone": "298"
                },
                {
                    "code": "FJ",
                    "name": "FIJI",
                    "currency": {
                        "currencyName": "FIJI DOLLAR",
                        "currencyCode": "FJD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -16.578193,
                        "longitude": 179.414413
                    },
                    "capital": "SUVA",
                    "phone": "679"
                },
                {
                    "code": "FI",
                    "name": "FINLAND",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 61.92411,
                        "longitude": 25.748151
                    },
                    "capital": "HELSINKI",
                    "phone": "358"
                },
                {
                    "code": "FR",
                    "name": "FRANCE",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 46.227638,
                        "longitude": 2.213749
                    },
                    "capital": "PARIS",
                    "phone": "33"
                },
                {
                    "code": "GF",
                    "name": "FRENCH GUIANA",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 3.933889,
                        "longitude": -53.125782
                    },
                    "capital": "CAYENNE",
                    "phone": "594"
                },
                {
                    "code": "TF",
                    "name": "FRENCH SOUTHERN TERRITORIES",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": -49.280366,
                        "longitude": 69.348557
                    },
                    "capital": "",
                    "phone": "00262"
                },
                {
                    "code": "GA",
                    "name": "GABON",
                    "currency": {
                        "currencyName": "CFA FRANC BEAC",
                        "currencyCode": "XAF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": -0.803689,
                        "longitude": 11.609444
                    },
                    "capital": "LIBREVILLE",
                    "phone": "241"
                },
                {
                    "code": "GM",
                    "name": "GAMBIA",
                    "currency": {
                        "currencyName": "GAMBIAN DALASI",
                        "currencyCode": "GMD",
                        "currencySymbol": "D"
                    },
                    "geo": {
                        "latitude": 13.443182,
                        "longitude": -15.310139
                    },
                    "capital": "BANJUL",
                    "phone": "220"
                },
                {
                    "code": "GE",
                    "name": "GEORGIA",
                    "currency": {
                        "currencyName": "GEORGIAN LARI",
                        "currencyCode": "GEL",
                        "currencySymbol": "ლ"
                    },
                    "geo": {
                        "latitude": 42.315407,
                        "longitude": 43.356892
                    },
                    "capital": "TBILISI",
                    "phone": "995"
                },
                {
                    "code": "DE",
                    "name": "GERMANY",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 51.165691,
                        "longitude": 10.451526
                    },
                    "capital": "BERLIN",
                    "phone": "49"
                },
                {
                    "code": "GH",
                    "name": "GHANA",
                    "currency": {
                        "currencyName": "GHANAIAN CEDI",
                        "currencyCode": "GHS",
                        "currencySymbol": "₵"
                    },
                    "geo": {
                        "latitude": 7.946527,
                        "longitude": -1.023194
                    },
                    "capital": "ACCRA",
                    "phone": "233"
                },
                {
                    "code": "GI",
                    "name": "GIBRALTAR",
                    "currency": {
                        "currencyName": "GIBRALTAR POUND",
                        "currencyCode": "GIP",
                        "currencySymbol": "£"
                    },
                    "geo": {
                        "latitude": 36.137741,
                        "longitude": -5.345374
                    },
                    "capital": "GIBRALTAR",
                    "phone": "350"
                },
                {
                    "code": "GB",
                    "name": "GREAT BRITAIN",
                    "currency": {
                        "currencyName": "POUND STERLING",
                        "currencyCode": "GBP",
                        "currencySymbol": "£"
                    },
                    "geo": {
                        "latitude": 55.378051,
                        "longitude": -3.435973
                    },
                    "capital": "LONDON",
                    "phone": "44"
                },
                {
                    "code": "GR",
                    "name": "GREECE",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 39.074208,
                        "longitude": 21.824312
                    },
                    "capital": "ATHENS",
                    "phone": "30"
                },
                {
                    "code": "GL",
                    "name": "GREENLAND",
                    "currency": {
                        "currencyName": "DANISH KRONE",
                        "currencyCode": "DKK",
                        "currencySymbol": "kr"
                    },
                    "geo": {
                        "latitude": 71.706936,
                        "longitude": -42.604303
                    },
                    "capital": "GODTHAB",
                    "phone": "299"
                },
                {
                    "code": "GD",
                    "name": "GRENADA",
                    "currency": {
                        "currencyName": "EAST CARRIBEAN DOLLAR",
                        "currencyCode": "XCD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 12.262776,
                        "longitude": -61.604171
                    },
                    "capital": "ST. GEORGE'S",
                    "phone": "1-473"
                },
                {
                    "code": "GP",
                    "name": "GUADELOUPE (FRENCH)",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 16.995971,
                        "longitude": -62.067641
                    },
                    "capital": "BASSE-TERRE",
                    "phone": "590"
                },
                {
                    "code": "GU",
                    "name": "GUAM (USA)",
                    "currency": {
                        "currencyName": "US DOLLAR",
                        "currencyCode": "USD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 13.444304,
                        "longitude": 144.793731
                    },
                    "capital": "AGANA",
                    "phone": "1-671"
                },
                {
                    "code": "GT",
                    "name": "GUATEMALA",
                    "currency": {
                        "currencyName": "GUATEMALAN QUETZAL",
                        "currencyCode": "QTQ",
                        "currencySymbol": "Q"
                    },
                    "geo": {
                        "latitude": 15.783471,
                        "longitude": -90.230759
                    },
                    "capital": "GUATEMALA CITY",
                    "phone": "502"
                },
                {
                    "code": "GG",
                    "name": "GUERNSEY",
                    "currency": {
                        "currencyName": "POUND STERLING",
                        "currencyCode": "GGP",
                        "currencySymbol": "£"
                    },
                    "geo": {
                        "latitude": 49.465691,
                        "longitude": -2.585278
                    },
                    "capital": "ST. PETER PORT",
                    "phone": "0044"
                },
                {
                    "code": "GN",
                    "name": "GUINEA",
                    "currency": {
                        "currencyName": "GUINEA FRANC",
                        "currencyCode": "GNF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": 9.945587,
                        "longitude": -9.696645
                    },
                    "capital": "CONAKRY",
                    "phone": "224"
                },
                {
                    "code": "GW",
                    "name": "GUINEA BISSAU",
                    "currency": {
                        "currencyName": "GUINEA-BISSAU PESO",
                        "currencyCode": "GWP",
                        "currencySymbol": "pesos"
                    },
                    "geo": {
                        "latitude": 11.803749,
                        "longitude": -15.180413
                    },
                    "capital": "BISSAU",
                    "phone": "245"
                },
                {
                    "code": "GY",
                    "name": "GUYANA",
                    "currency": {
                        "currencyName": "GUYANA DOLLAR",
                        "currencyCode": "GYD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 4.860416,
                        "longitude": -58.93018
                    },
                    "capital": "GEORGETOWN",
                    "phone": "592"
                },
                {
                    "code": "HT",
                    "name": "HAITI",
                    "currency": {
                        "currencyName": "HAITIAN GOURDE",
                        "currencyCode": "HTG",
                        "currencySymbol": "G"
                    },
                    "geo": {
                        "latitude": 18.971187,
                        "longitude": -72.285215
                    },
                    "capital": "PORT-AU-PRINCE",
                    "phone": "509"
                },
                {
                    "code": "HM",
                    "name": "HEARD ISLAND AND MCDONALD ISLANDS",
                    "currency": {
                        "currencyName": "AUSTRALIAN DOLLAR",
                        "currencyCode": "AUD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -53.08181,
                        "longitude": 73.504158
                    },
                    "capital": "",
                    "phone": "00672"
                },
                {
                    "code": "HN",
                    "name": "HONDURAS",
                    "currency": {
                        "currencyName": "HONDURAN LEMPIRA",
                        "currencyCode": "HNL",
                        "currencySymbol": "L"
                    },
                    "geo": {
                        "latitude": 15.199999,
                        "longitude": -86.241905
                    },
                    "capital": "TEGUCIGALPA",
                    "phone": "504"
                },
                {
                    "code": "HK",
                    "name": "HONG KONG",
                    "currency": {
                        "currencyName": "HONG KONG DOLLAR",
                        "currencyCode": "HKD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 22.396428,
                        "longitude": 114.109497
                    },
                    "capital": "VICTORIA",
                    "phone": "852"
                },
                {
                    "code": "HU",
                    "name": "HUNGARY",
                    "currency": {
                        "currencyName": "HUNGARIAN FORINT",
                        "currencyCode": "HUF",
                        "currencySymbol": "Ft"
                    },
                    "geo": {
                        "latitude": 47.162494,
                        "longitude": 19.503304
                    },
                    "capital": "BUDAPEST",
                    "phone": "36"
                },
                {
                    "code": "IS",
                    "name": "ICELAND",
                    "currency": {
                        "currencyName": "ICELAND KRONA",
                        "currencyCode": "ISK",
                        "currencySymbol": "kr"
                    },
                    "geo": {
                        "latitude": 64.963051,
                        "longitude": -19.020835
                    },
                    "capital": "REYKJAVIK",
                    "phone": "354"
                },
                {
                    "code": "IN",
                    "name": "INDIA",
                    "currency": {
                        "currencyName": "INDIAN RUPEE",
                        "currencyCode": "INR",
                        "currencySymbol": "₹"
                    },
                    "geo": {
                        "latitude": 20.593684,
                        "longitude": 78.96288
                    },
                    "capital": "NEW DELHI",
                    "phone": "91"
                },
                {
                    "code": "ID",
                    "name": "INDONESIA",
                    "currency": {
                        "currencyName": "INDONESIAN RUPIAH",
                        "currencyCode": "IDR",
                        "currencySymbol": "Rp"
                    },
                    "geo": {
                        "latitude": -0.789275,
                        "longitude": 113.921327
                    },
                    "capital": "JAKARTA",
                    "phone": "62"
                },
                {
                    "code": "IR",
                    "name": "IRAN",
                    "currency": {
                        "currencyName": "IRANIAN RIAL",
                        "currencyCode": "IRR",
                        "currencySymbol": "﷼"
                    },
                    "geo": {
                        "latitude": 32.427908,
                        "longitude": 53.688046
                    },
                    "capital": "TEHRAN",
                    "phone": "98"
                },
                {
                    "code": "IQ",
                    "name": "IRAQ",
                    "currency": {
                        "currencyName": "IRAQI DINAR",
                        "currencyCode": "IQD",
                        "currencySymbol": "ع.د"
                    },
                    "geo": {
                        "latitude": 33.223191,
                        "longitude": 43.679291
                    },
                    "capital": "BAGHDAD",
                    "phone": "964"
                },
                {
                    "code": "IE",
                    "name": "IRELAND",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 53.41291,
                        "longitude": -8.24389
                    },
                    "capital": "DUBLIN",
                    "phone": "353"
                },
                {
                    "code": "IM",
                    "name": "ISLE OF MAN",
                    "currency": {
                        "currencyName": "POUND STERLING",
                        "currencyCode": "GBP",
                        "currencySymbol": "£"
                    },
                    "geo": {
                        "latitude": 54.236107,
                        "longitude": -4.548056
                    },
                    "capital": "DOUGLAS",
                    "phone": "0044"
                },
                {
                    "code": "IL",
                    "name": "ISRAEL",
                    "currency": {
                        "currencyName": "ISRAELI NEW SHEKEL",
                        "currencyCode": "ILS",
                        "currencySymbol": "₪"
                    },
                    "geo": {
                        "latitude": 31.046051,
                        "longitude": 34.851612
                    },
                    "capital": "JERUSALEM",
                    "phone": "972"
                },
                {
                    "code": "IT",
                    "name": "ITALY",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 41.87194,
                        "longitude": 12.56738
                    },
                    "capital": "ROME",
                    "phone": "39"
                },
                {
                    "code": "CI",
                    "name": "IVORY COAST",
                    "currency": {
                        "currencyName": "CFA FRANC BCEAO",
                        "currencyCode": "XOF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": 7.539989,
                        "longitude": -5.54708
                    },
                    "capital": "ABIDJAN",
                    "phone": "225"
                },
                {
                    "code": "JM",
                    "name": "JAMAICA",
                    "currency": {
                        "currencyName": "JAMAICAN DOLLAR",
                        "currencyCode": "JMD",
                        "currencySymbol": "J$"
                    },
                    "geo": {
                        "latitude": 18.109581,
                        "longitude": -77.297508
                    },
                    "capital": "KINGSTON",
                    "phone": "1-876"
                },
                {
                    "code": "JP",
                    "name": "JAPAN",
                    "currency": {
                        "currencyName": "JAPANESE YEN",
                        "currencyCode": "JPY",
                        "currencySymbol": "¥"
                    },
                    "geo": {
                        "latitude": 36.204824,
                        "longitude": 138.252924
                    },
                    "capital": "TOKYO",
                    "phone": "81"
                },
                {
                    "code": "JE",
                    "name": "JERSEY",
                    "currency": {
                        "currencyName": "POUND STERLING",
                        "currencyCode": "GBP",
                        "currencySymbol": "£"
                    },
                    "geo": {
                        "latitude": 49.214439,
                        "longitude": -2.13125
                    },
                    "capital": "SAINT HELIER",
                    "phone": "0044"
                },
                {
                    "code": "JO",
                    "name": "JORDAN",
                    "currency": {
                        "currencyName": "JORDANIAN DINAR",
                        "currencyCode": "JOD",
                        "currencySymbol": "د.ا"
                    },
                    "geo": {
                        "latitude": 30.585164,
                        "longitude": 36.238414
                    },
                    "capital": "AMMAN",
                    "phone": "962"
                },
                {
                    "code": "KZ",
                    "name": "KAZAKHSTAN",
                    "currency": {
                        "currencyName": "KAZAKHSTAN TENGE",
                        "currencyCode": "KZT",
                        "currencySymbol": "лв"
                    },
                    "geo": {
                        "latitude": 48.019573,
                        "longitude": 66.923684
                    },
                    "capital": "ASTANA",
                    "phone": "7"
                },
                {
                    "code": "KE",
                    "name": "KENYA",
                    "currency": {
                        "currencyName": "KENYAN SHILLING",
                        "currencyCode": "KES",
                        "currencySymbol": "KSh"
                    },
                    "geo": {
                        "latitude": -0.023559,
                        "longitude": 37.906193
                    },
                    "capital": "NAIROBI",
                    "phone": "254"
                },
                {
                    "code": "KI",
                    "name": "KIRIBATI",
                    "currency": {
                        "currencyName": "AUSTRALIAN DOLLAR",
                        "currencyCode": "AUD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -3.370417,
                        "longitude": -168.734039
                    },
                    "capital": "TARAWA",
                    "phone": "686"
                },
                {
                    "code": "KP",
                    "name": "KOREA-NORTH",
                    "currency": {
                        "currencyName": "NORTH KOREAN WON",
                        "currencyCode": "KPW",
                        "currencySymbol": "₩"
                    },
                    "geo": {
                        "latitude": 40.339852,
                        "longitude": 127.510093
                    },
                    "capital": "PYONGYANG",
                    "phone": "850"
                },
                {
                    "code": "KR",
                    "name": "KOREA-SOUTH",
                    "currency": {
                        "currencyName": "KOREAN WON",
                        "currencyCode": "KRW",
                        "currencySymbol": "₩"
                    },
                    "geo": {
                        "latitude": 35.907757,
                        "longitude": 127.766922
                    },
                    "capital": "SEOUL",
                    "phone": "82"
                },
                {
                    "code": "KW",
                    "name": "KUWAIT",
                    "currency": {
                        "currencyName": "KUWAITI DINAR",
                        "currencyCode": "KWD",
                        "currencySymbol": "د.ك"
                    },
                    "geo": {
                        "latitude": 29.31166,
                        "longitude": 47.481766
                    },
                    "capital": "KUWAIT CITY",
                    "phone": "965"
                },
                {
                    "code": "KG",
                    "name": "KYRGYZSTAN",
                    "currency": {
                        "currencyName": "SOM",
                        "currencyCode": "KGS",
                        "currencySymbol": "лв"
                    },
                    "geo": {
                        "latitude": 41.20438,
                        "longitude": 74.766098
                    },
                    "capital": "BISHKEK",
                    "phone": "996"
                },
                {
                    "code": "LA",
                    "name": "LAOS",
                    "currency": {
                        "currencyName": "LAO KIP",
                        "currencyCode": "LAK",
                        "currencySymbol": "₭"
                    },
                    "geo": {
                        "latitude": 19.85627,
                        "longitude": 102.495496
                    },
                    "capital": "VIENTIANE",
                    "phone": "856"
                },
                {
                    "code": "LV",
                    "name": "LATVIA",
                    "currency": {
                        "currencyName": "LATVIAN LATS",
                        "currencyCode": "LVL",
                        "currencySymbol": "Ls"
                    },
                    "geo": {
                        "latitude": 56.879635,
                        "longitude": 24.603189
                    },
                    "capital": "RIGA",
                    "phone": "371"
                },
                {
                    "code": "LB",
                    "name": "LEBANON",
                    "currency": {
                        "currencyName": "LEBANESE POUND",
                        "currencyCode": "LBP",
                        "currencySymbol": "£"
                    },
                    "geo": {
                        "latitude": 33.854721,
                        "longitude": 35.862285
                    },
                    "capital": "BEIRUT",
                    "phone": "961"
                },
                {
                    "code": "LS",
                    "name": "LESOTHO",
                    "currency": {
                        "currencyName": "LESOTHO LOTI",
                        "currencyCode": "LSL",
                        "currencySymbol": "L"
                    },
                    "geo": {
                        "latitude": -29.609988,
                        "longitude": 28.233608
                    },
                    "capital": "MASERU",
                    "phone": "266"
                },
                {
                    "code": "LR",
                    "name": "LIBERIA",
                    "currency": {
                        "currencyName": "LIBERIAN DOLLAR",
                        "currencyCode": "LRD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 6.428055,
                        "longitude": -9.429499
                    },
                    "capital": "MONROVIA",
                    "phone": "231"
                },
                {
                    "code": "LY",
                    "name": "LIBYA",
                    "currency": {
                        "currencyName": "LIBYAN DINAR",
                        "currencyCode": "LYD",
                        "currencySymbol": "ل.د"
                    },
                    "geo": {
                        "latitude": 26.3351,
                        "longitude": 17.228331
                    },
                    "capital": "TRIPOLI",
                    "phone": "218"
                },
                {
                    "code": "LI",
                    "name": "LIECHTENSTEIN",
                    "currency": {
                        "currencyName": "SWISS FRANC",
                        "currencyCode": "CHF",
                        "currencySymbol": "CHF"
                    },
                    "geo": {
                        "latitude": 47.166,
                        "longitude": 9.555373
                    },
                    "capital": "VADUZ",
                    "phone": "423"
                },
                {
                    "code": "LT",
                    "name": "LITHUANIA",
                    "currency": {
                        "currencyName": "LITHUANIAN LITAS",
                        "currencyCode": "LTL",
                        "currencySymbol": "Lt"
                    },
                    "geo": {
                        "latitude": 55.169438,
                        "longitude": 23.881275
                    },
                    "capital": "VILNIUS",
                    "phone": "370"
                },
                {
                    "code": "LU",
                    "name": "LUXEMBOURG",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 49.815273,
                        "longitude": 6.129583
                    },
                    "capital": "LUXEMBOURG",
                    "phone": "352"
                },
                {
                    "code": "MO",
                    "name": "MACAU",
                    "currency": {
                        "currencyName": "MACAU PATACA",
                        "currencyCode": "MOP",
                        "currencySymbol": "P"
                    },
                    "geo": {
                        "latitude": 22.198745,
                        "longitude": 113.543873
                    },
                    "capital": "MACAU",
                    "phone": "853"
                },
                {
                    "code": "MK",
                    "name": "MACEDONIA",
                    "currency": {
                        "currencyName": "DENAR",
                        "currencyCode": "MKD",
                        "currencySymbol": "ден"
                    },
                    "geo": {
                        "latitude": 41.608635,
                        "longitude": 21.745275
                    },
                    "capital": "SKOPJE",
                    "phone": "389"
                },
                {
                    "code": "MG",
                    "name": "MADAGASCAR",
                    "currency": {
                        "currencyName": "MALAGASY FRANC",
                        "currencyCode": "MGF",
                        "currencySymbol": "Ar"
                    },
                    "geo": {
                        "latitude": -18.766947,
                        "longitude": 46.869107
                    },
                    "capital": "ANTANANARIVO",
                    "phone": "261"
                },
                {
                    "code": "MW",
                    "name": "MALAWI",
                    "currency": {
                        "currencyName": "MALAWI KWACHA",
                        "currencyCode": "MWK",
                        "currencySymbol": "MK"
                    },
                    "geo": {
                        "latitude": -13.254308,
                        "longitude": 34.301525
                    },
                    "capital": "LILONGWE",
                    "phone": "265"
                },
                {
                    "code": "MY",
                    "name": "MALAYSIA",
                    "currency": {
                        "currencyName": "MALAYSIAN RINGGIT",
                        "currencyCode": "MYR",
                        "currencySymbol": "RM"
                    },
                    "geo": {
                        "latitude": 4.210484,
                        "longitude": 101.975766
                    },
                    "capital": "KUALA LUMPUR",
                    "phone": "60"
                },
                {
                    "code": "MV",
                    "name": "MALDIVES",
                    "currency": {
                        "currencyName": "MALDIVE RUFIYAA",
                        "currencyCode": "MVR",
                        "currencySymbol": "Rf."
                    },
                    "geo": {
                        "latitude": 3.202778,
                        "longitude": 73.22068
                    },
                    "capital": "MALE",
                    "phone": "960"
                },
                {
                    "code": "ML",
                    "name": "MALI",
                    "currency": {
                        "currencyName": "CFA FRANC BCEAO",
                        "currencyCode": "XOF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": 17.570692,
                        "longitude": -3.996166
                    },
                    "capital": "BAMAKO",
                    "phone": "223"
                },
                {
                    "code": "MT",
                    "name": "MALTA",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 35.937496,
                        "longitude": 14.375416
                    },
                    "capital": "VALLETTA",
                    "phone": "356"
                },
                {
                    "code": "MH",
                    "name": "MARSHALL ISLANDS",
                    "currency": {
                        "currencyName": "US DOLLAR",
                        "currencyCode": "USD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 7.131474,
                        "longitude": 171.184478
                    },
                    "capital": "MAJURO",
                    "phone": "692"
                },
                {
                    "code": "MQ",
                    "name": "MARTINIQUE (FRENCH)",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 14.641528,
                        "longitude": -61.024174
                    },
                    "capital": "FORT-DE-FRANCE",
                    "phone": "596"
                },
                {
                    "code": "MR",
                    "name": "MAURITANIA",
                    "currency": {
                        "currencyName": "MAURITANIAN OUGUIYA",
                        "currencyCode": "MRO",
                        "currencySymbol": "UM"
                    },
                    "geo": {
                        "latitude": 21.00789,
                        "longitude": -10.940835
                    },
                    "capital": "NOUAKCHOTT",
                    "phone": "222"
                },
                {
                    "code": "MU",
                    "name": "MAURITIUS",
                    "currency": {
                        "currencyName": "MAURITIUS RUPEE",
                        "currencyCode": "MUR",
                        "currencySymbol": "₨"
                    },
                    "geo": {
                        "latitude": -20.348404,
                        "longitude": 57.552152
                    },
                    "capital": "PORT LOUIS",
                    "phone": "230"
                },
                {
                    "code": "YT",
                    "name": "MAYOTTE",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": -12.8275,
                        "longitude": 45.166244
                    },
                    "capital": "DZAOUDZI",
                    "phone": "269"
                },
                {
                    "code": "MX",
                    "name": "MEXICO",
                    "currency": {
                        "currencyName": "MEXICAN NUEVO PESO",
                        "currencyCode": "MXN",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 23.634501,
                        "longitude": -102.552784
                    },
                    "capital": "MEXICO CITY",
                    "phone": "52"
                },
                {
                    "code": "FM",
                    "name": "MICRONESIA",
                    "currency": {
                        "currencyName": "US DOLLAR",
                        "currencyCode": "USD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 7.425554,
                        "longitude": 150.550812
                    },
                    "capital": "PALIKIR",
                    "phone": "691"
                },
                {
                    "code": "MD",
                    "name": "MOLDOVA",
                    "currency": {
                        "currencyName": "MOLDOVAN LEU",
                        "currencyCode": "MDL",
                        "currencySymbol": "L"
                    },
                    "geo": {
                        "latitude": 47.411631,
                        "longitude": 28.369885
                    },
                    "capital": "KISHINEV",
                    "phone": "373"
                },
                {
                    "code": "MC",
                    "name": "MONACO",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 43.750298,
                        "longitude": 7.412841
                    },
                    "capital": "MONACO",
                    "phone": "377"
                },
                {
                    "code": "MN",
                    "name": "MONGOLIA",
                    "currency": {
                        "currencyName": "MONGOLIAN TUGRIK",
                        "currencyCode": "MNT",
                        "currencySymbol": "₮"
                    },
                    "geo": {
                        "latitude": 46.862496,
                        "longitude": 103.846656
                    },
                    "capital": "ULAN BATOR",
                    "phone": "976"
                },
                {
                    "code": "ME",
                    "name": "MONTENEGRO",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 42.708678,
                        "longitude": 19.37439
                    },
                    "capital": "PODGORICA",
                    "phone": "382"
                },
                {
                    "code": "MS",
                    "name": "MONTSERRAT",
                    "currency": {
                        "currencyName": "EAST CARIBBEAN DOLLAR",
                        "currencyCode": "XCD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 16.742498,
                        "longitude": -62.187366
                    },
                    "capital": "PLYMOUTH",
                    "phone": "1-664"
                },
                {
                    "code": "MA",
                    "name": "MOROCCO",
                    "currency": {
                        "currencyName": "MOROCCAN DIRHAM",
                        "currencyCode": "MAD",
                        "currencySymbol": "د.م."
                    },
                    "geo": {
                        "latitude": 31.791702,
                        "longitude": -7.09262
                    },
                    "capital": "RABAT",
                    "phone": "212"
                },
                {
                    "code": "MZ",
                    "name": "MOZAMBIQUE",
                    "currency": {
                        "currencyName": "MOZAMBIQUE METICAL",
                        "currencyCode": "MZN",
                        "currencySymbol": "MT"
                    },
                    "geo": {
                        "latitude": -18.665695,
                        "longitude": 35.529562
                    },
                    "capital": "MAPUTO",
                    "phone": "258"
                },
                {
                    "code": "MM",
                    "name": "MYANMAR",
                    "currency": {
                        "currencyName": "MYANMAR KYAT",
                        "currencyCode": "MMK",
                        "currencySymbol": "K"
                    },
                    "geo": {
                        "latitude": 21.913965,
                        "longitude": 95.956223
                    },
                    "capital": "NAYPYIDAW",
                    "phone": "95"
                },
                {
                    "code": "NA",
                    "name": "NAMIBIA",
                    "currency": {
                        "currencyName": "NAMIBIAN DOLLAR",
                        "currencyCode": "NAD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -22.95764,
                        "longitude": 18.49041
                    },
                    "capital": "WINDHOEK",
                    "phone": "264"
                },
                {
                    "code": "NR",
                    "name": "NAURU",
                    "currency": {
                        "currencyName": "AUSTRALIAN DOLLAR",
                        "currencyCode": "AUD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -0.522778,
                        "longitude": 166.931503
                    },
                    "capital": "YAREN",
                    "phone": "674"
                },
                {
                    "code": "NP",
                    "name": "NEPAL",
                    "currency": {
                        "currencyName": "NEPALESE RUPEE",
                        "currencyCode": "NPR",
                        "currencySymbol": "₨"
                    },
                    "geo": {
                        "latitude": 28.394857,
                        "longitude": 84.124008
                    },
                    "capital": "KATHMANDU",
                    "phone": "977"
                },
                {
                    "code": "NL",
                    "name": "NETHERLANDS",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 52.132633,
                        "longitude": 5.291266
                    },
                    "capital": "AMSTERDAM",
                    "phone": "31"
                },
                {
                    "code": "AN",
                    "name": "NETHERLANDS ANTILLES",
                    "currency": {
                        "currencyName": "NETHERLANDS ANTILLEAN GUILDER",
                        "currencyCode": "ANG",
                        "currencySymbol": "ƒ"
                    },
                    "geo": {
                        "latitude": 12.226079,
                        "longitude": -69.060087
                    },
                    "capital": "WILLEMSTAD",
                    "phone": "599"
                },
                {
                    "code": "NC",
                    "name": "NEW CALEDONIA (FRENCH)",
                    "currency": {
                        "currencyName": "CFP FRANC",
                        "currencyCode": "XPF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": -20.904305,
                        "longitude": 165.618042
                    },
                    "capital": "NOUMEA",
                    "phone": "687"
                },
                {
                    "code": "NZ",
                    "name": "NEW ZEALAND",
                    "currency": {
                        "currencyName": "NEW ZEALAND DOLLAR",
                        "currencyCode": "NZD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -40.900557,
                        "longitude": 174.885971
                    },
                    "capital": "WELLINGTON",
                    "phone": "64"
                },
                {
                    "code": "NI",
                    "name": "NICARAGUA",
                    "currency": {
                        "currencyName": "NICARAGUAN CORDOBA ORO",
                        "currencyCode": "NIO",
                        "currencySymbol": "C$"
                    },
                    "geo": {
                        "latitude": 12.865416,
                        "longitude": -85.207229
                    },
                    "capital": "MANAGUA",
                    "phone": "505"
                },
                {
                    "code": "NE",
                    "name": "NIGER",
                    "currency": {
                        "currencyName": "CFA FRANC BCEAO",
                        "currencyCode": "XOF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": 17.607789,
                        "longitude": 8.081666
                    },
                    "capital": "NIAMEY",
                    "phone": "227"
                },
                {
                    "code": "NG",
                    "name": "NIGERIA",
                    "currency": {
                        "currencyName": "NIGERIAN NAIRA",
                        "currencyCode": "NGN",
                        "currencySymbol": "₦"
                    },
                    "geo": {
                        "latitude": 9.081999,
                        "longitude": 8.675277
                    },
                    "capital": "LAGOS",
                    "phone": "234"
                },
                {
                    "code": "NU",
                    "name": "NIUE",
                    "currency": {
                        "currencyName": "NEW ZEALAND DOLLAR",
                        "currencyCode": "NZD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -19.054445,
                        "longitude": -169.867233
                    },
                    "capital": "ALOFI",
                    "phone": "683"
                },
                {
                    "code": "NF",
                    "name": "NORFOLK ISLAND",
                    "currency": {
                        "currencyName": "AUSTRALIAN DOLLAR",
                        "currencyCode": "AUD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -29.040835,
                        "longitude": 167.954712
                    },
                    "capital": "KINGSTON",
                    "phone": "672"
                },
                {
                    "code": "MP",
                    "name": "NORTHERN MARIANA ISLANDS",
                    "currency": {
                        "currencyName": "US DOLLAR",
                        "currencyCode": "USD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 17.33083,
                        "longitude": 145.38469
                    },
                    "capital": "SAIPAN",
                    "phone": "670"
                },
                {
                    "code": "NO",
                    "name": "NORWAY",
                    "currency": {
                        "currencyName": "NORWEGIAN KRONE",
                        "currencyCode": "NOK",
                        "currencySymbol": "kr"
                    },
                    "geo": {
                        "latitude": 60.472024,
                        "longitude": 8.468946
                    },
                    "capital": "OSLO",
                    "phone": "47"
                },
                {
                    "code": "OM",
                    "name": "OMAN",
                    "currency": {
                        "currencyName": "OMANI RIAL",
                        "currencyCode": "OMR",
                        "currencySymbol": "﷼"
                    },
                    "geo": {
                        "latitude": 21.512583,
                        "longitude": 55.923255
                    },
                    "capital": "MUSCAT",
                    "phone": "968"
                },
                {
                    "code": "PK",
                    "name": "PAKISTAN",
                    "currency": {
                        "currencyName": "PAKISTAN RUPEE",
                        "currencyCode": "PKR",
                        "currencySymbol": "₨"
                    },
                    "geo": {
                        "latitude": 30.375321,
                        "longitude": 69.345116
                    },
                    "capital": "ISLAMABAD",
                    "phone": "92"
                },
                {
                    "code": "PW",
                    "name": "PALAU",
                    "currency": {
                        "currencyName": "US DOLLAR",
                        "currencyCode": "USD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 7.51498,
                        "longitude": 134.58252
                    },
                    "capital": "KOROR",
                    "phone": "680"
                },
                {
                    "code": "PA",
                    "name": "PANAMA",
                    "currency": {
                        "currencyName": "PANAMANIAN BALBOA",
                        "currencyCode": "PAB",
                        "currencySymbol": "B/."
                    },
                    "geo": {
                        "latitude": 8.537981,
                        "longitude": -80.782127
                    },
                    "capital": "PANAMA CITY",
                    "phone": "507"
                },
                {
                    "code": "PG",
                    "name": "PAPUA NEW GUINEA",
                    "currency": {
                        "currencyName": "PAPUA NEW GUINEA KINA",
                        "currencyCode": "PGK",
                        "currencySymbol": "K"
                    },
                    "geo": {
                        "latitude": -6.314993,
                        "longitude": 143.95555
                    },
                    "capital": "PORT MORESBY",
                    "phone": "675"
                },
                {
                    "code": "PY",
                    "name": "PARAGUAY",
                    "currency": {
                        "currencyName": "PARAGUAY GUARANI",
                        "currencyCode": "PYG",
                        "currencySymbol": "Gs"
                    },
                    "geo": {
                        "latitude": -23.442503,
                        "longitude": -58.443832
                    },
                    "capital": "ASUNCION",
                    "phone": "595"
                },
                {
                    "code": "PE",
                    "name": "PERU",
                    "currency": {
                        "currencyName": "PERUVIAN NUEVO SOL",
                        "currencyCode": "PEN",
                        "currencySymbol": "S/."
                    },
                    "geo": {
                        "latitude": -9.189967,
                        "longitude": -75.015152
                    },
                    "capital": "LIMA",
                    "phone": "51"
                },
                {
                    "code": "PH",
                    "name": "PHILIPPINES",
                    "currency": {
                        "currencyName": "PHILIPPINE PESO",
                        "currencyCode": "PHP",
                        "currencySymbol": "₱"
                    },
                    "geo": {
                        "latitude": 12.879721,
                        "longitude": 121.774017
                    },
                    "capital": "MANILA",
                    "phone": "63"
                },
                {
                    "code": "PN",
                    "name": "PITCAIRN ISLAND",
                    "currency": {
                        "currencyName": "NEW ZEALAND DOLLAR",
                        "currencyCode": "NZD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -24.703615,
                        "longitude": -127.439308
                    },
                    "capital": "ADAMSTOWN",
                    "phone": "0064"
                },
                {
                    "code": "PL",
                    "name": "POLAND",
                    "currency": {
                        "currencyName": "POLISH ZLOTY",
                        "currencyCode": "PLN",
                        "currencySymbol": "zł"
                    },
                    "geo": {
                        "latitude": 51.919438,
                        "longitude": 19.145136
                    },
                    "capital": "WARSAW",
                    "phone": "48"
                },
                {
                    "code": "PF",
                    "name": "POLYNESIA (FRENCH)",
                    "currency": {
                        "currencyName": "CFP FRANC",
                        "currencyCode": "XPF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": -17.679742,
                        "longitude": -149.406843
                    },
                    "capital": "PAPEETE",
                    "phone": "689"
                },
                {
                    "code": "PT",
                    "name": "PORTUGAL",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 39.399872,
                        "longitude": -8.224454
                    },
                    "capital": "LISBON",
                    "phone": "351"
                },
                {
                    "code": "PR",
                    "name": "PUERTO RICO",
                    "currency": {
                        "currencyName": "US DOLLAR",
                        "currencyCode": "USD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 18.220833,
                        "longitude": -66.590149
                    },
                    "capital": "SAN JUAN",
                    "phone": "1-787"
                },
                {
                    "code": "QA",
                    "name": "QATAR",
                    "currency": {
                        "currencyName": "QATARI RIAL",
                        "currencyCode": "QAR",
                        "currencySymbol": "﷼"
                    },
                    "geo": {
                        "latitude": 25.354826,
                        "longitude": 51.183884
                    },
                    "capital": "DOHA",
                    "phone": "974"
                },
                {
                    "code": "RE",
                    "name": "REUNION (FRENCH)",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": -21.115141,
                        "longitude": 55.536384
                    },
                    "capital": "SAINT-DENIS",
                    "phone": "262"
                },
                {
                    "code": "RO",
                    "name": "ROMANIA",
                    "currency": {
                        "currencyName": "ROMANIAN NEW LEU",
                        "currencyCode": "RON",
                        "currencySymbol": "lei"
                    },
                    "geo": {
                        "latitude": 45.943161,
                        "longitude": 24.96676
                    },
                    "capital": "BUCHAREST",
                    "phone": "40"
                },
                {
                    "code": "RU",
                    "name": "RUSSIA",
                    "currency": {
                        "currencyName": "RUSSIAN RUBLE",
                        "currencyCode": "RUB",
                        "currencySymbol": "₽"
                    },
                    "geo": {
                        "latitude": 61.52401,
                        "longitude": 105.318756
                    },
                    "capital": "MOSCOW",
                    "phone": "7"
                },
                {
                    "code": "RW",
                    "name": "RWANDA",
                    "currency": {
                        "currencyName": "RWANDA FRANC",
                        "currencyCode": "RWF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": -1.940278,
                        "longitude": 29.873888
                    },
                    "capital": "KIGALI",
                    "phone": "250"
                },
                {
                    "code": "SH",
                    "name": "SAINT HELENA",
                    "currency": {
                        "currencyName": "ST. HELENA POUND",
                        "currencyCode": "SHP",
                        "currencySymbol": "£"
                    },
                    "geo": {
                        "latitude": -24.143474,
                        "longitude": -10.030696
                    },
                    "capital": "JAMESTOWN",
                    "phone": "290"
                },
                {
                    "code": "KN",
                    "name": "SAINT KITTS & NEVIS ANGUILLA",
                    "currency": {
                        "currencyName": "EAST CARIBBEAN DOLLAR",
                        "currencyCode": "XCD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 17.357822,
                        "longitude": -62.782998
                    },
                    "capital": "BASSETERRE",
                    "phone": "1-869"
                },
                {
                    "code": "LC",
                    "name": "SAINT LUCIA",
                    "currency": {
                        "currencyName": "EAST CARIBBEAN DOLLAR",
                        "currencyCode": "XCD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 13.909444,
                        "longitude": -60.978893
                    },
                    "capital": "CASTRIES",
                    "phone": "1-758"
                },
                {
                    "code": "PM",
                    "name": "SAINT PIERRE AND MIQUELON",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 46.941936,
                        "longitude": -56.27111
                    },
                    "capital": "ST. PIERRE",
                    "phone": "508"
                },
                {
                    "code": "VC",
                    "name": "SAINT VINCENT & GRENADINES",
                    "currency": {
                        "currencyName": "EAST CARIBBEAN DOLLAR",
                        "currencyCode": "XCD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 12.984305,
                        "longitude": -61.287228
                    },
                    "capital": "KINGSTOWN",
                    "phone": "1-784"
                },
                {
                    "code": "WS",
                    "name": "SAMOA",
                    "currency": {
                        "currencyName": "SAMOAN TALA",
                        "currencyCode": "WST",
                        "currencySymbol": "T"
                    },
                    "geo": {
                        "latitude": -13.759029,
                        "longitude": -172.104629
                    },
                    "capital": "APIA",
                    "phone": "684"
                },
                {
                    "code": "SM",
                    "name": "SAN MARINO",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 43.94236,
                        "longitude": 12.457777
                    },
                    "capital": "SAN MARINO",
                    "phone": "378"
                },
                {
                    "code": "ST",
                    "name": "SAO TOME AND PRINCIPE",
                    "currency": {
                        "currencyName": "DOBRA",
                        "currencyCode": "STD",
                        "currencySymbol": "Db"
                    },
                    "geo": {
                        "latitude": 0.18636,
                        "longitude": 6.613081
                    },
                    "capital": "SAO TOME",
                    "phone": "239"
                },
                {
                    "code": "SA",
                    "name": "SAUDI ARABIA",
                    "currency": {
                        "currencyName": "SAUDI RIYAL",
                        "currencyCode": "SAR",
                        "currencySymbol": "﷼"
                    },
                    "geo": {
                        "latitude": 23.885942,
                        "longitude": 45.079162
                    },
                    "capital": "RIYADH",
                    "phone": "966"
                },
                {
                    "code": "SN",
                    "name": "SENEGAL",
                    "currency": {
                        "currencyName": "CFA FRANC BCEAO",
                        "currencyCode": "XOF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": 14.497401,
                        "longitude": -14.452362
                    },
                    "capital": "DAKAR",
                    "phone": "221"
                },
                {
                    "code": "RS",
                    "name": "SERBIA",
                    "currency": {
                        "currencyName": "DINAR",
                        "currencyCode": "RSD",
                        "currencySymbol": "Дин."
                    },
                    "geo": {
                        "latitude": 44.016521,
                        "longitude": 21.005859
                    },
                    "capital": "BELGRADE",
                    "phone": "381"
                },
                {
                    "code": "SC",
                    "name": "SEYCHELLES",
                    "currency": {
                        "currencyName": "SEYCHELLES RUPEE",
                        "currencyCode": "SCR",
                        "currencySymbol": "₨"
                    },
                    "geo": {
                        "latitude": -4.679574,
                        "longitude": 55.491977
                    },
                    "capital": "VICTORIA",
                    "phone": "248"
                },
                {
                    "code": "SL",
                    "name": "SIERRA LEONE",
                    "currency": {
                        "currencyName": "SIERRA LEONE LEONE",
                        "currencyCode": "SLL",
                        "currencySymbol": "Le"
                    },
                    "geo": {
                        "latitude": 8.460555,
                        "longitude": -11.779889
                    },
                    "capital": "FREETOWN",
                    "phone": "232"
                },
                {
                    "code": "SG",
                    "name": "SINGAPORE",
                    "currency": {
                        "currencyName": "SINGAPORE DOLLAR",
                        "currencyCode": "SGD",
                        "currencySymbol": "S$"
                    },
                    "geo": {
                        "latitude": 1.352083,
                        "longitude": 103.819836
                    },
                    "capital": "SINGAPORE",
                    "phone": "65"
                },
                {
                    "code": "SK",
                    "name": "SLOVAKIA",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 48.669026,
                        "longitude": 19.699024
                    },
                    "capital": "BRATISLAVA",
                    "phone": "421"
                },
                {
                    "code": "SI",
                    "name": "SLOVENIA",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 46.151241,
                        "longitude": 14.995463
                    },
                    "capital": "LJUBLJANA",
                    "phone": "386"
                },
                {
                    "code": "SB",
                    "name": "SOLOMON ISLANDS",
                    "currency": {
                        "currencyName": "SOLOMON ISLANDS DOLLAR",
                        "currencyCode": "SBD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -9.64571,
                        "longitude": 160.156194
                    },
                    "capital": "HONIARA",
                    "phone": "677"
                },
                {
                    "code": "SO",
                    "name": "SOMALIA",
                    "currency": {
                        "currencyName": "SOMALI SHILLING",
                        "currencyCode": "SOS",
                        "currencySymbol": "S"
                    },
                    "geo": {
                        "latitude": 5.152149,
                        "longitude": 46.199616
                    },
                    "capital": "MOGADISHU",
                    "phone": "252"
                },
                {
                    "code": "ZA",
                    "name": "SOUTH AFRICA",
                    "currency": {
                        "currencyName": "SOUTH AFRICAN RAND",
                        "currencyCode": "ZAR",
                        "currencySymbol": "R"
                    },
                    "geo": {
                        "latitude": -30.559482,
                        "longitude": 22.937506
                    },
                    "capital": "PRETORIA",
                    "phone": "27"
                },
                {
                    "code": "GS",
                    "name": "SOUTH GEORGIA & SOUTH SANDWICH ISLANDS",
                    "currency": {
                        "currencyName": "POUND STERLING",
                        "currencyCode": "GBP",
                        "currencySymbol": "£"
                    },
                    "geo": {
                        "latitude": -54.429579,
                        "longitude": -36.587909
                    },
                    "capital": "",
                    "phone": "00500"
                },
                {
                    "code": "SS",
                    "name": "SOUTH SUDAN",
                    "currency": {
                        "currencyName": "SOUTH SUDAN POUND",
                        "currencyCode": "SSP",
                        "currencySymbol": "£"
                    },
                    "geo": {
                        "latitude": 7.9631,
                        "longitude": 30.1589
                    },
                    "capital": "RAMCIEL",
                    "phone": "00211"
                },
                {
                    "code": "ES",
                    "name": "SPAIN",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 40.463667,
                        "longitude": -3.74922
                    },
                    "capital": "MADRID",
                    "phone": "34"
                },
                {
                    "code": "LK",
                    "name": "SRI LANKA",
                    "currency": {
                        "currencyName": "SRI LANKA RUPEE",
                        "currencyCode": "LKR",
                        "currencySymbol": "₨"
                    },
                    "geo": {
                        "latitude": 7.873054,
                        "longitude": 80.771797
                    },
                    "capital": "COLOMBO",
                    "phone": "94"
                },
                {
                    "code": "SD",
                    "name": "SUDAN",
                    "currency": {
                        "currencyName": "SUDANESE POUND",
                        "currencyCode": "SDG",
                        "currencySymbol": "£"
                    },
                    "geo": {
                        "latitude": 12.862807,
                        "longitude": 30.217636
                    },
                    "capital": "KHARTOUM",
                    "phone": "249"
                },
                {
                    "code": "SR",
                    "name": "SURINAME",
                    "currency": {
                        "currencyName": "SURINAM DOLLAR",
                        "currencyCode": "SRD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 3.919305,
                        "longitude": -56.027783
                    },
                    "capital": "PARAMARIBO",
                    "phone": "597"
                },
                {
                    "code": "SJ",
                    "name": "SVALBARD AND JAN MAYEN ISLANDS",
                    "currency": {
                        "currencyName": "NORWEGIAN KRONE",
                        "currencyCode": "NOK",
                        "currencySymbol": "kr"
                    },
                    "geo": {
                        "latitude": 77.553604,
                        "longitude": 23.670272
                    },
                    "capital": "LONGYEARBYEN",
                    "phone": "0047"
                },
                {
                    "code": "SZ",
                    "name": "SWAZILAND",
                    "currency": {
                        "currencyName": "SWAZILAND LILANGENI",
                        "currencyCode": "SZL",
                        "currencySymbol": "L"
                    },
                    "geo": {
                        "latitude": -26.522503,
                        "longitude": 31.465866
                    },
                    "capital": "MBABANE",
                    "phone": "268"
                },
                {
                    "code": "SE",
                    "name": "SWEDEN",
                    "currency": {
                        "currencyName": "SWEDISH KRONA",
                        "currencyCode": "SEK",
                        "currencySymbol": "kr"
                    },
                    "geo": {
                        "latitude": 60.128161,
                        "longitude": 18.643501
                    },
                    "capital": "STOCKHOLM",
                    "phone": "46"
                },
                {
                    "code": "CH",
                    "name": "SWITZERLAND",
                    "currency": {
                        "currencyName": "SWISS FRANC",
                        "currencyCode": "CHF",
                        "currencySymbol": "CHF"
                    },
                    "geo": {
                        "latitude": 46.818188,
                        "longitude": 8.227512
                    },
                    "capital": "BERN",
                    "phone": "41"
                },
                {
                    "code": "SY",
                    "name": "SYRIA",
                    "currency": {
                        "currencyName": "SYRIAN POUND",
                        "currencyCode": "SYP",
                        "currencySymbol": "£"
                    },
                    "geo": {
                        "latitude": 34.802075,
                        "longitude": 38.996815
                    },
                    "capital": "DAMASCUS",
                    "phone": "963"
                },
                {
                    "code": "TW",
                    "name": "TAIWAN",
                    "currency": {
                        "currencyName": "TAIWAN DOLLAR",
                        "currencyCode": "TWD",
                        "currencySymbol": "NT$"
                    },
                    "geo": {
                        "latitude": 23.69781,
                        "longitude": 120.960515
                    },
                    "capital": "TAIPEI",
                    "phone": "886"
                },
                {
                    "code": "TJ",
                    "name": "TAJIKISTAN",
                    "currency": {
                        "currencyName": "TAJIK SOMONI",
                        "currencyCode": "TJS",
                        "currencySymbol": "SM"
                    },
                    "geo": {
                        "latitude": 38.861034,
                        "longitude": 71.276093
                    },
                    "capital": "DUSHANBE",
                    "phone": "992"
                },
                {
                    "code": "TZ",
                    "name": "TANZANIA",
                    "currency": {
                        "currencyName": "TANZANIAN SHILLING",
                        "currencyCode": "TZS",
                        "currencySymbol": "TSh"
                    },
                    "geo": {
                        "latitude": -6.369028,
                        "longitude": 34.888822
                    },
                    "capital": "DODOMA",
                    "phone": "255"
                },
                {
                    "code": "TH",
                    "name": "THAILAND",
                    "currency": {
                        "currencyName": "THAI BAHT",
                        "currencyCode": "THB",
                        "currencySymbol": "฿"
                    },
                    "geo": {
                        "latitude": 15.870032,
                        "longitude": 100.992541
                    },
                    "capital": "BANGKOK",
                    "phone": "66"
                },
                {
                    "code": "TG",
                    "name": "TOGO",
                    "currency": {
                        "currencyName": "CFA FRANC BCEAO",
                        "currencyCode": "XOF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": 8.619543,
                        "longitude": 0.824782
                    },
                    "capital": "LOME",
                    "phone": "228"
                },
                {
                    "code": "TK",
                    "name": "TOKELAU",
                    "currency": {
                        "currencyName": "NEW ZEALAND DOLLAR",
                        "currencyCode": "NZD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -8.967363,
                        "longitude": -171.855881
                    },
                    "capital": "",
                    "phone": "690"
                },
                {
                    "code": "TO",
                    "name": "TONGA",
                    "currency": {
                        "currencyName": "TONGAN PA'ANGA",
                        "currencyCode": "TOP",
                        "currencySymbol": "T$"
                    },
                    "geo": {
                        "latitude": -21.178986,
                        "longitude": -175.198242
                    },
                    "capital": "NUKU'ALOFA",
                    "phone": "676"
                },
                {
                    "code": "TT",
                    "name": "TRINIDAD AND TOBAGO",
                    "currency": {
                        "currencyName": "TRINIDAD AND TOBAGO DOLLAR",
                        "currencyCode": "TTD",
                        "currencySymbol": "TT$"
                    },
                    "geo": {
                        "latitude": 10.691803,
                        "longitude": -61.222503
                    },
                    "capital": "PORT OF SPAIN",
                    "phone": "1-868"
                },
                {
                    "code": "TN",
                    "name": "TUNISIA",
                    "currency": {
                        "currencyName": "TUNISIAN DOLLAR",
                        "currencyCode": "TND",
                        "currencySymbol": "د.ت"
                    },
                    "geo": {
                        "latitude": 33.886917,
                        "longitude": 9.537499
                    },
                    "capital": "TUNIS",
                    "phone": "216"
                },
                {
                    "code": "TR",
                    "name": "TURKEY",
                    "currency": {
                        "currencyName": "TURKISH LIRA",
                        "currencyCode": "TRY",
                        "currencySymbol": "TL"
                    },
                    "geo": {
                        "latitude": 38.963745,
                        "longitude": 35.243322
                    },
                    "capital": "ANKARA",
                    "phone": "90"
                },
                {
                    "code": "TM",
                    "name": "TURKMENISTAN",
                    "currency": {
                        "currencyName": "MANAT",
                        "currencyCode": "TMT",
                        "currencySymbol": "m"
                    },
                    "geo": {
                        "latitude": 38.969719,
                        "longitude": 59.556278
                    },
                    "capital": "ASHGABAT",
                    "phone": "993"
                },
                {
                    "code": "TC",
                    "name": "TURKS AND CAICOS ISLANDS",
                    "currency": {
                        "currencyName": "US DOLLAR",
                        "currencyCode": "USD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 21.694025,
                        "longitude": -71.797928
                    },
                    "capital": "GRAND TURK",
                    "phone": "1-649"
                },
                {
                    "code": "TV",
                    "name": "TUVALU",
                    "currency": {
                        "currencyName": "AUSTRALIAN DOLLAR",
                        "currencyCode": "AUD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -7.109535,
                        "longitude": 177.64933
                    },
                    "capital": "FUNAFUTI",
                    "phone": "688"
                },
                {
                    "code": "UK",
                    "name": "UNITED KINGDOM",
                    "currency": {
                        "currencyName": "POUND STERLING",
                        "currencyCode": "GBP",
                        "currencySymbol": "£"
                    },
                    "geo": {
                        "latitude": 55.3781,
                        "longitude": -3.436
                    },
                    "capital": "LONDON",
                    "phone": "44"
                },
                {
                    "code": "US",
                    "name": "USA",
                    "currency": {
                        "currencyName": "US DOLLAR",
                        "currencyCode": "USD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 37.09024,
                        "longitude": -95.712891
                    },
                    "capital": "WASHINGTON",
                    "phone": "1"
                },
                {
                    "code": "UM",
                    "name": "USA MINOR OUTLYING ISLANDS",
                    "currency": {
                        "currencyName": "US DOLLAR",
                        "currencyCode": "USD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": -0.374350,
                        "longitude": -159.996719
                    },
                    "capital": "",
                    "phone": "001"
                },
                {
                    "code": "UG",
                    "name": "UGANDA",
                    "currency": {
                        "currencyName": "UGANDA SHILLING",
                        "currencyCode": "UGX",
                        "currencySymbol": "USh"
                    },
                    "geo": {
                        "latitude": 1.373333,
                        "longitude": 32.290275
                    },
                    "capital": "KAMPALA",
                    "phone": "256"
                },
                {
                    "code": "UA",
                    "name": "UKRAINE",
                    "currency": {
                        "currencyName": "UKRAINE HRYVNIA",
                        "currencyCode": "UAH",
                        "currencySymbol": "₴"
                    },
                    "geo": {
                        "latitude": 48.379433,
                        "longitude": 31.16558
                    },
                    "capital": "KIEV",
                    "phone": "380"
                },
                {
                    "code": "AE",
                    "name": "UNITED ARAB EMIRATES",
                    "currency": {
                        "currencyName": "ARAB EMIRATES DIRHAM",
                        "currencyCode": "AED",
                        "currencySymbol": "د.إ"
                    },
                    "geo": {
                        "latitude": 23.424076,
                        "longitude": 53.847818
                    },
                    "capital": "ABU DHABI",
                    "phone": "971"
                },
                {
                    "code": "UY",
                    "name": "URUGUAY",
                    "currency": {
                        "currencyName": "URUGUAYAN PESO",
                        "currencyCode": "UYU",
                        "currencySymbol": "$U"
                    },
                    "geo": {
                        "latitude": -32.522779,
                        "longitude": -55.765835
                    },
                    "capital": "MONTEVIDEO",
                    "phone": "598"
                },
                {
                    "code": "UZ",
                    "name": "UZBEKISTAN",
                    "currency": {
                        "currencyName": "UZBEKISTAN SUM",
                        "currencyCode": "UZS",
                        "currencySymbol": "лв"
                    },
                    "geo": {
                        "latitude": 41.377491,
                        "longitude": 64.585262
                    },
                    "capital": "TASHKENT",
                    "phone": "998"
                },
                {
                    "code": "VU",
                    "name": "VANUATU",
                    "currency": {
                        "currencyName": "VANUATU VATU",
                        "currencyCode": "VUV",
                        "currencySymbol": "Vt"
                    },
                    "geo": {
                        "latitude": -15.376706,
                        "longitude": 166.959158
                    },
                    "capital": "PORT VILA",
                    "phone": "678"
                },
                {
                    "code": "VA",
                    "name": "VATICAN",
                    "currency": {
                        "currencyName": "EURO",
                        "currencyCode": "EUR",
                        "currencySymbol": "€"
                    },
                    "geo": {
                        "latitude": 41.902916,
                        "longitude": 12.453389
                    },
                    "capital": "VATICAN CITY",
                    "phone": "39"
                },
                {
                    "code": "VE",
                    "name": "VENEZUELA",
                    "currency": {
                        "currencyName": "VENEZUELAN BOLIVAR",
                        "currencyCode": "VEF",
                        "currencySymbol": "Bs"
                    },
                    "geo": {
                        "latitude": 6.42375,
                        "longitude": -66.58973
                    },
                    "capital": "CARACAS",
                    "phone": "58"
                },
                {
                    "code": "VN",
                    "name": "VIETNAM",
                    "currency": {
                        "currencyName": "VIETNAMESE DONG",
                        "currencyCode": "VND",
                        "currencySymbol": "₫"
                    },
                    "geo": {
                        "latitude": 14.058324,
                        "longitude": 108.277199
                    },
                    "capital": "HANOI",
                    "phone": "84"
                },
                {
                    "code": "VG",
                    "name": "VIRGIN ISLANDS (BRITISH)",
                    "currency": {
                        "currencyName": "US DOLLAR",
                        "currencyCode": "USD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 18.420695,
                        "longitude": -64.639968
                    },
                    "capital": "ROAD TOWN",
                    "phone": "1-284"
                },
                {
                    "code": "VI",
                    "name": "VIRGIN ISLANDS (USA)",
                    "currency": {
                        "currencyName": "US DOLLAR",
                        "currencyCode": "USD",
                        "currencySymbol": "$"
                    },
                    "geo": {
                        "latitude": 18.335765,
                        "longitude": -64.896335
                    },
                    "capital": "CHARLOTTE AMALIE",
                    "phone": "1-340"
                },
                {
                    "code": "WF",
                    "name": "WALLIS AND FUTUNA ISLANDS",
                    "currency": {
                        "currencyName": "CFP FRANC",
                        "currencyCode": "XPF",
                        "currencySymbol": "Fr"
                    },
                    "geo": {
                        "latitude": -13.768752,
                        "longitude": -177.156097
                    },
                    "capital": "MATA-UTU",
                    "phone": "681"
                },
                {
                    "code": "EH",
                    "name": "WESTERN SAHARA",
                    "currency": {
                        "currencyName": "MOROCCAN DIRHAM",
                        "currencyCode": "MAD",
                        "currencySymbol": "د.م."
                    },
                    "geo": {
                        "latitude": 24.215527,
                        "longitude": -12.885834
                    },
                    "capital": "EL AAIUN",
                    "phone": "00212"
                },
                {
                    "code": "YE",
                    "name": "YEMEN",
                    "currency": {
                        "currencyName": "YEMENI RIAL",
                        "currencyCode": "YER",
                        "currencySymbol": "﷼"
                    },
                    "geo": {
                        "latitude": 15.552727,
                        "longitude": 48.516388
                    },
                    "capital": "SAN'A",
                    "phone": "967"
                },
                {
                    "code": "ZM",
                    "name": "ZAMBIA",
                    "currency": {
                        "currencyName": "ZAMBIAN KWACHA",
                        "currencyCode": "ZMW",
                        "currencySymbol": "ZK"
                    },
                    "geo": {
                        "latitude": -13.133897,
                        "longitude": 27.849332
                    },
                    "capital": "LUSAKA",
                    "phone": "260"
                },
                {
                    "code": "ZW",
                    "name": "ZIMBABWE",
                    "currency": {
                        "currencyName": "ZIMBABWE DOLLAR",
                        "currencyCode": "ZWD",
                        "currencySymbol": "Z$"
                    },
                    "geo": {
                        "latitude": -19.015438,
                        "longitude": 29.154857
                    },
                    "capital": "HARARE",
                    "phone": "263"
                }
            ]
            linkClicked = function(label, jsonLdObject) {
                if(!label) {
                    return;
                }
                jsonObject = {
                    action: label,
                    data: jsonLdObject
                }
                if(isDesktop){
                    onLinkClickedCallback("ejsLinkClicked",jsonObject);    
                } else {
                    onLinkClickedCallback(jsonObject);
                }
             }
            showOrHide = function() {
                if(document.getElementById('showOrHideButton').text === 'Show') {
                    document.getElementById('showOrHideButton').text = 'Hide'
                } else {
                    document.getElementById('showOrHideButton').text = 'Show'
                }
            }
            toggleHSNTable = function() {
                if (document.getElementById("HSNTable").style.display === "none") {
                    document.getElementById("HSNTable").style.display = "block";
                    document.getElementById('HSNTableLabel').text = 'Hide HSN Table'
                } else {
                    document.getElementById("HSNTable").style.display = "none";
                    document.getElementById('HSNTableLabel').text = 'Show HSN Table'
                }
            }

            toggleOrderedItemTable = function(index) {
                if (document.getElementById("orderedItemTable" + index).style.display === "none") {
                    document.getElementById("orderedItemTable" + index).style.display = "block"
                    document.getElementById("orderedItemTableText" + index).text= "Hide"
                } else{
                    document.getElementById("orderedItemTable" + index).style.display = "none"
                    document.getElementById("orderedItemTableText" + index).text= "Show"
                }
            }
            
            getAttachedText = function(status, subType) {
                var attachedText = "";
                var tabNameArray = ["", "Purchase Order", "Purchase Order", "Invoice", "Invoice", "Payment", "Payment"]
                if(subType === "returnRequest" || subType === "returnOrder"){
                    if(subType === "returnRequest"){
                        attachedText = "Return Request"
                    }else if(subType === "returnOrder"){
                        attachedText = "Return Order"
                    }
                }else if(subType === "debitNote" || subType === "creditNote"){
                    if(subType === "debitNote"){
                        attachedText = "Debit Note"
                    }else if(subType === "creditNote"){
                        attachedText = "Credit Note"
                    }
                }else{
                    attachedText = tabNameArray[status]
                }
                return attachedText
            }
            %>
            <style>
                .docTitle{
                    text-transform: capitalize;
                    font-size: 2em;
                    margin-bottom:0.4rem;
                }
                .warningIconColor{ color:orange; }
                .grnPending{ color:red }
                .grnResolved{ color:green; }
                .checkIconColor{ color:green  }
                .grayText { color: gray;  }
                .organization{color:#545454; }
                .address {
                    margin-bottom: 0.5rem;
                    color        : #c9c9c9;
                    font-weight  : normal;
                }
                .buyerAddress {
                    color        : #c9c9c9;
                    font-weight  : normal;
                    margin-bottom:0.5rem;
                }
                .mt_0{ margin-top:0.3rem; }
                .mt_1{ margin-top:1rem; }
                .mb_1{margin-bottom: 1rem;}
                .mb_2{margin-bottom: 2rem;}
                .capitalize{ text-tranform:capitalize;  }
                .horizontalOverflow{overflow-x:auto}
                .textAlignRight{text-align:right;}
                .textCenter{text-align:center;}
                .floatRight{float:right;}
                .ml_1{margin-left:1rem}
                .amtChargeColor{color:black}
                .termsColor{color:#c9c9c9;}
                .attachmentDividerColor{color:#e8e6e6;}
                .tooltip {
                    position: relative;
                    display: inline-block;
                }  
                .tooltip .tooltiptext {
                    visibility: hidden;
                    width: 200px;
                    background-color: rgb(59, 59, 59);
                    color: #fff;
                    text-align: center;
                    border-radius: 6px;
                    padding: 5px;
                    
                    /* Position the tooltip */
                    position: absolute;
                    z-index: 1;
                    top: 100%;
                    left: 50%;
                }
                .tooltip:hover .tooltiptext {
                    visibility: visible;
                }
            </style>
            <div id="divToPrint">
                
                <div class="ant-row">
                    <div class="ant-col-md-12 ant-col-xs-24">
                        <%if(jsonLd.status === "0" && jsonLd.subType && jsonLd.subType === 'evalRequest'){%>
                            <p class="nomargin docTitle">Eval Request</p>                        
                        <%}else if(jsonLd['@subType']){%>
                            <% if(jsonLd['@subType'] === "logistics") {%>
                                <p class="nomargin docTitle" ><%=docInfo.currentTab%></p>
                            <%}else{%>
                                <p class="nomargin docTitle" ><%=jsonLd['@subType']%></p>
                            <%}%>
                        <%}else{%>
                            <p class="nomargin docTitle" >
                                <% if (docInfo.currentTab === 'purchaseOrder') { %>
                                    Purchase Order
                                    <%} else { %>
                                    <%=docInfo.currentTab%>
                                <% } %>
                            </p>
                        <%}%>
                        <% if (jsonLd.provider && jsonLd.provider.logoUrl) { %>
                            <img alt="logo" src=<%= jsonLd.provider.logoUrl%> class="logo" />
                        <% } %>
                        <% if (docInfo.alignedInfoText) { %>
                            <div class="iconComponent">
                                <div >
                                    <i aria-label="icon: warning" class="anticon anticon-warning warningIconColor" ><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="warning" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z"></path></svg></i>
                                    <span><%=docInfo.alignedInfoText%></span>
                                </div>
                            </div>
                        <% } %>
                        
                        <%if((jsonLd.status === "5") && (docInfo.noOfDocuments > 0)){%>
                            <%if(Number(docInfo.amountReceived) >= (Number(docInfo.amountDue))+docInfo.noteValuesInfo.creditNote + docInfo.noteValuesInfo.debitNote){%>
                                <span>Payment Completed</span>
                            <%}else{%>
                                <span>Partial Payment Done</span>
                            <%}%>
                        <%}%>
                        <div>
                            <%if(docInfo.typeOfDocument === "Grn"){%>
                                <span>GRN Status: </span>
                                <%if(jsonLd.status === "0"){%>
                                    <span class="grnPending">Pending</span>
                                <%}else{%>
                                    <span class="grnResolved">Resolved</span>
                                <%}%>
                            <%}%>
                        </div>
                       
                        <%if(jsonLd.provider){%>
                            <% if(jsonLd.provider.worksFor)  { %>
                                <h5 class="nomargin organization"><%=jsonLd.provider.worksFor.name%></h5>
                            <%} else if(jsonLd.provider.WorksFor) { %>
                                <h5 class="nomargin organization"><%=jsonLd.provider.WorksFor.name%></h5>
                            <% } %>
                            <%if(jsonLd.provider.name){%>
                                <p class="nomargin grayText"><%=jsonLd.provider.name%></p>
                            <%}%>
                            <%if(jsonLd.provider.email){%>
                                <p class="nomargin grayText"><%=jsonLd.provider.email%></p>
                            <%}%>
                            <%if(jsonLd.provider.address && jsonLd.provider.address.streetAddress){%>
                                <p class="nomargin grayText mt_0"><%=jsonLd.provider.address.streetAddress%></p>
                            <%}%>
                            <%if(jsonLd.provider.address && jsonLd.provider.address.addressLocality){%>
                                <p class="nomargin grayText"><%=jsonLd.provider.address.addressLocality%></p>
                            <%}%>
                            <%if(jsonLd.provider.city){%>
                                <p class="nomargin grayText"><%=jsonLd.provider.city%></p>
                            <%}%>
                            <%if(jsonLd.provider.address && jsonLd.provider.address.addressRegion){%>
                                <p class="nomargin grayText"><%=jsonLd.provider.address.addressRegion%></p>
                            <%}%>
                            <%if(jsonLd.provider.address && jsonLd.provider.address.postalCode){%>
                                <p class="nomargin grayText"><%=jsonLd.provider.address.postalCode%></p>
                            <%}%>
                            <%if(jsonLd.provider.telephone){%>
                                <p class="nomargin grayText"><%=jsonLd.provider.telephone%></p>
                            <%}%>
                            <%if(jsonLd.provider.taxId){%>
                                <p class="nomargin grayText mt_0">GST: <%=jsonLd.provider.taxId%></p>
                            <%}%>
                        <%}%>
                        
                        <% if (jsonLd.consignee) {%>
                            <div>
                            <p class="nomargin address">Consignee</p>
                            <p class="nomargin"><%=jsonLd.consignee.name%></p>
                            <p class="nomargin grayText"><%=jsonLd.consignee.organisation%></p>
                            <p class="nomargin grayText"><%=jsonLd.consignee.email%></p>
                            <p class="nomargin grayText"><%=jsonLd.consignee.streetAddress%></p>
                            <p class="nomargin grayText"><%=jsonLd.consignee.addressRegion%></p>
                            </div>
                        <%}%>
                        <p class="nomargin buyerAddress mt_1">Buyer</p>
                        <%if(jsonLd.customer){%>
                            <% if(jsonLd.customer.worksFor)  { %>
                                <h5 class="nomargin organization"><%=jsonLd.customer.worksFor.name%></h5>
                            <%} else if(jsonLd.customer.WorksFor) { %>
                                <h5 class="nomargin organization"><%=jsonLd.customer.WorksFor.name%></h5>
                            <% } %>
                            <%if(jsonLd.customer.name){%>
                                <p class="nomargin grayText"><%=jsonLd.customer.name%></p>
                            <%}%>
                            <%if(jsonLd.customer.email){%>
                                <p class="nomargin grayText"><%=jsonLd.customer.email%></p>
                            <%}%>
                            <%if(jsonLd.customer.address && jsonLd.customer.address.streetAddress){%>
                                <p class="nomargin grayText mt_0"><%=jsonLd.customer.address.streetAddress%></p>
                            <%}%>
                            <%if(jsonLd.customer.address && jsonLd.customer.address.addressLocality){%>
                                <p class="nomargin grayText"><%=jsonLd.customer.address.addressLocality%></p>
                            <%}%>
                            <%if(jsonLd.customer.city){%>
                                <p class="nomargin grayText"> <%=jsonLd.customer.city%></p>
                            <%}%>
                            <%if(jsonLd.customer.address && jsonLd.customer.address.addressRegion){%>
                                <p class="nomargin"> <%=jsonLd.customer.address.addressRegion%></p>
                            <%}%>
                            <%if(jsonLd.customer.address && jsonLd.customer.address.postalCode){%>
                                <p class="nomargin grayText"> <%=jsonLd.customer.address.postalCode%></p>
                            <%}%>
                            <%if(jsonLd.customer.telephone){%>
                                <p class="nomargin grayText"> <%=jsonLd.customer.telephone%></p>
                            <%}%>
                            <%if(jsonLd.customer.taxId){%>
                                <p class="nomargin grayText mt_0">GST: <%=jsonLd.customer.taxId%></p>
                            <%}%>
                        <%}%>
                    </div>
                    <div class="ant-col-md-12 ant-col-xs-24">
                        <div class="ant-row">
                            <div class="ant-col-md-12 ant-col-xs-24">
                                <div class="mt_1">
                                    <%if((jsonLd.status !== "2") && (jsonLd.status !== "4") && (jsonLd.status !== "6") && (jsonLd.status !== "9") && (jsonLd.status !== "11")){%>
                                        <p class="tooltip nomargin address">
                                            <i aria-label="icon: check-circle" class="anticon anticon-check-circle checkIconColor"><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="check-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"></path><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path></svg></i>
                                            &nbsp;&nbsp;
                                            <%=docInfo.fetchStatus%>
                                            <span class="tooltiptext">Multi signature, Authentic Document</span>
                                        </p>
                                    <%}else{%>
                                        <p class="tooltip nomargin address">
                                            <i aria-label="icon: warning" class="anticon anticon-warning warningIconColor"><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="warning" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z"></path></svg></i>
                                            &nbsp;&nbsp;
                                            <%=docInfo.fetchStatus%>
                                            <span class="tooltiptext">Non-Contract Purchase Order</span>
                                        </p>
                                    <%}%>
                                   
                                    <p class="nomargin">
                                        <%if(jsonLd.transactionType === "1"){%>
                                            <div class="tooltip">
                                                <i aria-label="icon: global" class="anticon anticon-global"><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="global" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z"></path></svg></i>
                                                <span class="tooltiptext">Public</span>
                                            </div>
                                        <%}else if(jsonLd.transactionType === "2"){%>
                                            <div class="tooltip">
                                                <i aria-label="icon: key" class="anticon anticon-key"><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="key" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5l-41.1 41.1-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-44.9 44.9-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-65.3 65.3a8.03 8.03 0 0 0 0 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6A304.06 304.06 0 0 0 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644c-60.9 0-118.2-23.7-161.2-66.8-43.1-43-66.8-100.3-66.8-161.2 0-60.9 23.7-118.2 66.8-161.2 43-43.1 100.3-66.8 161.2-66.8 60.9 0 118.2 23.7 161.2 66.8 43.1 43 66.8 100.3 66.8 161.2 0 60.9-23.7 118.2-66.8 161.2z"></path></svg></i>
                                                <span class="tooltiptext">Protected</span>
                                            </div>
                                        <%}else if(jsonLd.transactionType === "3"){%>
                                            <div class="tooltip">
                                            <i aria-label="icon: lock" class="anticon anticon-lock"><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="lock" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z"></path></svg></i>
                                            <span class="tooltiptext">Private</span>
                                        </div>
                                        <%}else{%>
                                            <div class="tooltip">
                                                <i aria-label="icon: global" class="anticon anticon-global"><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="global" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z"></path></svg></i>
                                                <span class="tooltiptext">Public</span>
                                            </div>
                                        <%}%>
                                        &nbsp;                               
                                        <span >
                                            <%if(docInfo.docInternalId){%>
                                                <%=docInfo.docInternalId%>
                                            <%}else{%>
                                                <%=docInfo.docId%>
                                            <%}%>
                                        </span>
                                    </p>
                                </div>


                                <%if(jsonLd.expiryDate && jsonLd.expiryDate !== ""){%>
                                    <div class="mt_1">
                                        <p class="nomargin address">Expiry Date</p>
                                        <p class="nomargin">
                                            <%=docInfo.expiryDate%>
                                        </p>
                                    </div>
                                <%}%>
                                <div class="mt_1">
                                    <%if((Number(jsonLd.step)>1) && (docInfo.parentDocId) && (docInfo.contractInternalId)){%>
                                            <div>
                                                <p class="nomargin address">Contract Id</p>
                                                <%var data = JSON.stringify({parentDocId:docInfo.contractId,redirectTab:'contract'})%>
                                                <a class="nomargin" href="javascript:linkClicked('docIdNavigation',<%=data%>)">
                                                <div>
                                                     <%=docInfo.contractInternalId%>
                                                     
                                                </div>
                                                </a>
                                            </div>
                                    <%}%>
                                </div>
                                <div class="mt_1">

                                    <%if(docInfo.additionalProperties){%>
                                        <%var count = 0%>
                                        <%for(let [key, value] of Object.entries(docInfo.additionalProperties)){%>
                                            <%if(count == 2){%>
                                                <%break%>
                                            <%}%>
                                            <div>
                                                <p class="nomargin address capitalize"><%=key%></p>
                                                <p class="nomargin"><%=value%></p>
                                            </div>
                                            <%count++%>
                                        <%}%>
                                    <%}%>
                                </div>
                            </div>
                            <div class="ant-col-md-12 ant-col-xs-24">
                                <div class="mt_1 textAlignRight">
                                    <%if(jsonLd.referencesOrder.orderDate){%>
                                        <p class="nomargin address">Date Of Issue</p>
                                        <p class="nomargin">
                                        <%=docInfo.orderDate%>
                                        </p>
                                    <%}%>

                                    <div class="mt_1">
                                        <%if(jsonLd['@subType'] === "acceptNote"){%>
                                            <div>
                                                <p class="nomargin address">Contract Id</p>
                                                    <%if(docInfo.contractInternalId){%>
                                                        <%var data = JSON.stringify({parentDocId:docInfo.contractId,redirectTab:'contract'})%>
                                                            <a class="nomargin" href="javascript:linkClicked('docIdNavigation',<%=data%>)">
                                                                <div >
                                                                    <%=docInfo.contractInternalId%>
                                                                </div>
                                                            </a>
                                                    <%}else{%>
                                                        <div>---</div>
                                                    <%}%>
                                            </div>
                                            <div class="mt_1">
                                                <p class="nomargin address">Purchase Order Id</p>
                                                <%if(jsonLd.poId){%>
                                                    <%var data = JSON.stringify({parentDocId:jsonLd.poId,redirectTab:'purchaseOrder'})%>
                                                    <a class="nomargin" href="javascript:linkClicked('docIdNavigation',<%=data%>)">
                                                        <div>
                                                            <%if(docInfo && docInfo.receiptInternalId){%>
                                                                <%if(docInfo.receiptInternalId.length>20){%>
                                                                    <%=trimString(docInfo.receiptInternalId,20)%>
                                                                <%}else{%>
                                                                    <%=docInfo.receiptInternalId%>
                                                                <%}%>
                                                            <%}%>
                                                        </div>
                                                    </a>
                                                <%}else{%>
                                                    <div>---</div>
                                                <%}%>
                                            </div>
                                        <%}else if(jsonLd['@subType'] === "GRN"){%>
                                            <div>
                                                <p class="nomargin address">Purchase Order Id</p>
                                                <%if(jsonLd.poId){%>
                                                    <%var data = JSON.stringify({parentDocId:jsonLd.poId,redirectTab:'purchaseOrder'})%>
                                                    <a class="nomargin" href="javascript:linkClicked('docIdNavigation',<%=data%>)">
                                                        <div>
                                                            <%if(jsonLd.purchaseOrderNumber){%>
                                                                <%if(jsonLd.purchaseOrderNumber.length>20){%>
                                                                    <%=trimString(jsonLd.purchaseOrderNumber,20)%>
                                                                <%}else{%>
                                                                    <%=jsonLd.purchaseOrderNumber%>
                                                                <%}%>
                                                            <%}%>
                                                        </div>
                                                    </a>
                                                <%}else{%>
                                                    <div>---</div>
                                                <%}%>
                                            </div>
                                            <div  class="mt_1">
                                                <p class="nomargin address">Invoice Id</p>
                                                <%if(jsonLd.invoiceId){%>
                                                    <%var data = JSON.stringify({parentDocId:jsonLd.invoiceId,redirectTab:'invoice'})%>
                                                    <a class="nomargin" href="javascript:linkClicked('docIdNavigation',<%=data%>)">
                                                        <div>
                                                            <%if(jsonLd.invoiceNumber){%>
                                                                <%if(jsonLd.invoiceNumber.length>20){%>
                                                                    <%=trimString(jsonLd.invoiceNumber,20)%>
                                                                <%}else{%>
                                                                    <%=jsonLd.invoiceNumber%>
                                                                <%}%>
                                                            <%}%>
                                                        </div>
                                                    </a>
                                                <%}else{%>
                                                    <div>---</div>
                                                <%}%>
                                            </div>
                                        <%}else if(jsonLd['@subType'] === "returnRequest"){%>
                                            <div>
                                                <p class="nomargin address">Invoice Id</p>
                                                <%if(jsonLd.parentDocId){%>
                                                    <%var data = JSON.stringify({parentDocId:jsonLd.parentDocId,redirectTab:'invoice'})%>
                                                    <a class="nomargin" href="javascript:linkClicked('docIdNavigation',<%=data%>)">
                                                        <div>
                                                        <%if(docInfo.parentInternalDocId){%>
                                                            <%if(docInfo.parentInternalDocId.length>20){%>
                                                                <%=trimString(docInfo.parentInternalDocId,20)%>
                                                            <%}else{%>
                                                                <%=docInfo.parentInternalDocId%>
                                                            <%}%>
                                                        <%}%>
                                                        </div>
                                                    </a>
                                                <%}else{%>
                                                    <div>---</div>
                                                <%}%>
                                            </div>
                                        <%} else if(jsonLd['@subType'] === "returnOrder"){%>
                                            <div>
                                                <p class="nomargin address">Request Id</p>
                                                <%if(jsonLd.parentDocId){%>
                                                    <%var data = JSON.stringify({parentDocId:jsonLd.parentDocId,redirectTab:'returnRequest'})%>
                                                    <a class="nomargin" href="javascript:linkClicked('docIdNavigation',<%=data%>)">
                                                        <div>
                                                            <%if(docInfo.parentInternalDocId){%>
                                                                <%if(docInfo.parentInternalDocId.length>20){%>
                                                                    <%=trimString(docInfo.parentInternalDocId,20)%>
                                                                <%}else{%>
                                                                    <%=docInfo.parentInternalDocId%>
                                                                <%}%>
                                                            <%}%>
                                                           
                                                        </div>
                                                    </a>
                                                <%}else{%>
                                                    <div>---</div>
                                                <%}%>
                                            </div>
                                        <%}else{%>
                                            <%if(jsonLd.step === "0"){%>
                                                <div>
                                                    <p class="nomargin address">Contract Id</p>
                                                    <a class="nomargin" ><%=docInfo.receiptInternalId%></a>
                                                </div>
                                            <%}%>
                                            <%if(jsonLd.step === "1"){%>
                                                <div>
                                                    <p class="nomargin address">Contract Id</p>
                                                    <%if(jsonLd.parentDocId){%>
                                                        <%var data = JSON.stringify({parentDocId:jsonLd.parentDocId,redirectTab:'contract'})%>
                                                        <a class="nomargin" href="javascript:linkClicked('docIdNavigation',<%=data%>)">
                                                            <div >
                                                                <%=docInfo.parentInternalDocId%>
                                                                
                                                            </div>
                                                        </a>
                                                    <%}else{%>
                                                        <div>---</div>
                                                    <%}%>
                                                </div>
                                            <%}%>
                                            <%if(jsonLd.step === "2"){%>
                                                <div>
                                                    <p class="nomargin address">Purchase Order Id</p>
                                                    <%if(jsonLd.parentDocId){%>
                                                        <%var data = JSON.stringify({parentDocId:jsonLd.parentDocId,redirectTab:'purchaseOrder'})%>
                                                        <a class="nomargin" href="javascript:linkClicked('docIdNavigation',<%=data%>)">
                                                            <div >
                                                                <%if(docInfo.parentInternalDocId){%>
                                                                    <%if(docInfo.parentInternalDocId.length>20){%>
                                                                        <%=trimString(docInfo.parentInternalDocId,20)%>
                                                                    <%}else{%>
                                                                        <%=docInfo.parentInternalDocId%>
                                                                    <%}%>
                                                                <%}%>
                                                                
                                                            </div>
                                                        </a>
                                                    <%}else{%>
                                                        <div>---</div>
                                                    <%}%>
                                                </div>
                                            <%}%>
                                            <%if(jsonLd.step === "3"){%>
                                                <div>
                                                    <p class="nomargin address">Invoice Id</p>
                                                    <%if(jsonLd.parentDocId){%>
                                                        <%var data = JSON.stringify({parentDocId:jsonLd.parentDocId,redirectTab:'invoice'})%>
                                                        <a class="nomargin" href="javascript:linkClicked('docIdNavigation',<%=data%>)">
                                                            <div >
                                                                <%if(docInfo.parentInternalDocId){%>
                                                                    <%if(docInfo.parentInternalDocId.length>20){%>
                                                                        <%=trimString(docInfo.parentInternalDocId,20)%>
                                                                    <%}else{%>
                                                                        <%=docInfo.parentInternalDocId%>
                                                                    <%}%>
                                                                <%}%>
                                                               
                                                            </div>
                                                        </a>
                                                    <%}else{%>
                                                        <div>---</div>
                                                    <%}%>
                                                </div>
                                            <%}%>
                                            <%if(jsonLd.step === "4"){%>
                                                <div>
                                                    <p class="nomargin address">Invoice Id</p>
                                                    <%if(jsonLd.parentDocId){%>
                                                        <%var data = JSON.stringify({parentDocId:jsonLd.parentDocId,redirectTab:'invoice'})%>
                                                        <a class="nomargin" href="javascript:linkClicked('docIdNavigation',<%=data%>)">
                                                            <div >
                                                                <%if(docInfo.parentInternalDocId){%>
                                                                    <%if(docInfo.parentInternalDocId.length>20){%>
                                                                        <%=trimString(docInfo.parentInternalDocId,20)%>
                                                                    <%}else{%>
                                                                        <%=docInfo.parentInternalDocId%>
                                                                    <%}%>
                                                                <%}%>
                                                                
                                                            </div>
                                                        </a>
                                                    <%}else{%>
                                                        <div>---</div>
                                                    <%}%>
                                                </div>
                                            <%}%>
                                        <%}%>
                                       
                                       
                                        
                                    </div>

                                    <div class="total-table mt_1">
                                        <p class="nomargin address">Payment Terms</p>
                                        <p class="nomargin">
                                            <%=jsonLd.paymentTerms%> 
                                            <%if(jsonLd.paymentTerms && jsonLd.paymentTerms == 1) {%>
                                                day
                                            <%}else{%>
                                                days
                                            <%}%>
                                        </p>
                                    </div>
                                    <p class="nomargin address mt_1">
                                        Total Amount
                                    </p>
                                    <%var length = jsonLd.totalPaymentDue.price.toString().length;%>
                                    <%if(length>6){%>
                                        <p class="nomargin currency" id="amountDue" style="font-size:1.5rem;">
                                            <a style="cursor:none"><%=getCurrency(jsonLd.totalPaymentDue.price, docInfo.currency)%></a>
                                        </p>
                                    <%}else{%>
                                        <p class="nomargin currency" id="amountDue">
                                            <a style="cursor:none"><%=getCurrency(jsonLd.totalPaymentDue.price, docInfo.currency)%></a>
                                        </p>
                                    <%}%>
                                  
                                </div>
                            </div>

                        </div>
                    </div>
                    <%if(docInfo.partPurchaseOrder && docInfo.partPurchaseOrder.length > 0){%>
                        <div style="width: 100%">
                        <p class="ml_1 mt_1"><%=docInfo.partPurchaseOrder.length%> Part PO(s) Attached</p>
                        <%for(let index in docInfo.partPOInfos){%>
                            <div class="ml_1 mt_1">
                                <span><%=docInfo.partPOInfos[index].docInternalId%></span>
                                <a href="javascript:toggleOrderedItemTable(<%=index%>)" id=<%="orderedItemTableText" + index %> >
                                    Hide
                                </a>
                            </div>
                            <%var referencesOrder = docInfo.partPOInfos[index].referencesOrder %>
                            <div class="ant-table-wrapper horizontalOverflow mt_1" id=<%="orderedItemTable" + index %> >
                                <div class="ant-table ant-table-default ant-table-bordered ant-table-scroll-position-left">
                                    <div class="ant-table-content">
                                        <table class="ant-table-body">
                                            <thead class="ant-table-thead">
                                                <tr class="ant-table-row">
                                                    <th>Item</th>
                                                    <th>Type</th> 
                                                    <th>HSN Code</th>
                                                    <%var additionalColumns =  JSON.parse(referencesOrder.additionalColumns)%>
                                                    <%for(let i in additionalColumns){%>
                                                        <th><%=additionalColumns[i]%></th>
                                                    <%}%>
                                                    <th>Unit price</th>
                                                    <th>Quantity</th>
                                                    <th>SGST%</th>
                                                    <th>CGST%</th>
                                                    <th>IGST%</th>
                                                    <th>Discount%</th>
                                                    <th>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody class="ant-table-tbody">
                                            <% for (var i = 0; i < referencesOrder.orderedItem.length; i++) { %>
                                            <tr class="ant-table-row">
                                                <td style="min-width: 6rem;"><%= referencesOrder.orderedItem[i].orderedItem.name%> </td>
                                                <td><%= referencesOrder.orderedItem[i].orderedItem.category%></td>
                                                <td  class="textCenter">
                                                    <%if(referencesOrder.orderedItem[i].orderedItem.productId){%>
                                                        <%= referencesOrder.orderedItem[i].orderedItem.productId%>
                                                    <%}else{%>
                                                        <span>-</span>
                                                    <%}%>
                                                </td>
                                                
                                                <%var additionalColumns =  JSON.parse(referencesOrder.additionalColumns)%>
                                                <%if(additionalColumns.length>0){%>
                                                        <%let additionalObjects = getAdditionalPropertyAsObject(referencesOrder.orderedItem[i])%>
                                                        <%for(let i in additionalColumns){%>
                                                            <td class="textCenter">
                                                                <%=additionalObjects[additionalColumns[i]]%>
                                                            </td>
                                                        <%}%>
                                                <%}%>
                                                                                    
                                                <td><%=numberWithCommas(referencesOrder.orderedItem[i].orderedItem.offers.price, 2)%></td>
                                                <td><%=toFixed(referencesOrder.orderedItem[i].orderQuantity)%></td> 
                                                <% let addOnObject = getAddOnAsObject(referencesOrder.orderedItem[i].orderedItem.offers.addOn) %>
                                                <td class="textCenter">
                                                    <%if(addOnObject["SGST"]){%>
                                                        <%=toFixed(addOnObject["SGST"])%>
                                                    <%}else{%>
                                                        <span>-</span>
                                                    <%}%>
                                                </td>
                                                <td class="textCenter">
                                                    <%if(addOnObject["CGST"]){%>
                                                        <%=toFixed(addOnObject["CGST"])%>
                                                    <%}else{%>
                                                        <span>-</span>
                                                    <%}%>
                                                </td>
                                                <td class="textCenter">
                                                    <%if(addOnObject["IGST"]){%>
                                                        <%=toFixed(addOnObject["IGST"])%>
                                                    <%}else{%>
                                                        <span>-</span>
                                                    <%}%>
                                                </td>
                                                <td class="textCenter">
                                                    <%if(addOnObject["discount"]){%>
                                                        <%=toFixed(addOnObject["discount"])%>
                                                    <%}else{%>
                                                        <span>-</span>
                                                    <%}%>
                                                </td>
                                                <td>
                                                    <%var amt = referencesOrder.orderedItem[i].orderQuantity * referencesOrder.orderedItem[i].orderedItem.offers.price%>
                                                    <%=numberWithCommas(amt,2)%>
                                                </td> 
                                            </tr>
                                            <% } %>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        <%}%>
                        </div>
                    <%}else{%>
                        <div class="ant-table-wrapper horizontalOverflow mt_1">
                            <div class="ant-table ant-table-default ant-table-bordered ant-table-scroll-position-left">
                                <div class="ant-table-content">
                                    <table class="ant-table-body">
                                        <thead class="ant-table-thead">
                                            <tr class="ant-table-row">
                                                <th>Item</th>
                                                <th>Type</th> 
                                                <th>HSN Code</th>
                                                <%var additionalColumns =  JSON.parse(jsonLd.referencesOrder.additionalColumns)%>
                                                <%for(let i in additionalColumns){%>
                                                    <th><%=additionalColumns[i]%></th>
                                                <%}%>
                                                <th>Unit price</th>
                                                <th>Quantity</th>
                                                <th>SGST%</th>
                                                <th>CGST%</th>
                                                <th>IGST%</th>
                                                <th>Discount%</th>
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody class="ant-table-tbody">
                                        <% for (var i = 0; i < jsonLd.referencesOrder.orderedItem.length; i++) { %>
                                        <tr class="ant-table-row">
                                            <td style="min-width: 6rem;"><%= jsonLd.referencesOrder.orderedItem[i].orderedItem.name%> </td>
                                            <td><%= jsonLd.referencesOrder.orderedItem[i].orderedItem.category%></td>
                                            <td  class="textCenter">
                                                <%if(jsonLd.referencesOrder.orderedItem[i].orderedItem.productId){%>
                                                    <%= jsonLd.referencesOrder.orderedItem[i].orderedItem.productId%>
                                                <%}else{%>
                                                    <span>-</span>
                                                <%}%>
                                            </td>
                                            
                                            <%var additionalColumns =  JSON.parse(jsonLd.referencesOrder.additionalColumns)%>
                                            <%if(additionalColumns.length>0){%>
                                                    <%let additionalObjects = getAdditionalPropertyAsObject(jsonLd.referencesOrder.orderedItem[i])%>
                                                    <%for(let i in additionalColumns){%>
                                                        <td class="textCenter">
                                                            <%=additionalObjects[additionalColumns[i]]%>
                                                        </td>
                                                    <%}%>
                                            <%}%>
                                                                                
                                            <td><%=numberWithCommas(jsonLd.referencesOrder.orderedItem[i].orderedItem.offers.price, 2)%></td>
                                            <td><%=toFixed(jsonLd.referencesOrder.orderedItem[i].orderQuantity)%></td> 
                                            <% let addOnObject = getAddOnAsObject(jsonLd.referencesOrder.orderedItem[i].orderedItem.offers.addOn) %>
                                            <td class="textCenter">
                                                <%if(addOnObject["SGST"]){%>
                                                    <%=toFixed(addOnObject["SGST"])%>
                                                <%}else{%>
                                                    <span>-</span>
                                                <%}%>
                                            </td>
                                            <td class="textCenter">
                                                <%if(addOnObject["CGST"]){%>
                                                    <%=toFixed(addOnObject["CGST"])%>
                                                <%}else{%>
                                                    <span>-</span>
                                                <%}%>
                                            </td>
                                            <td class="textCenter">
                                                <%if(addOnObject["IGST"]){%>
                                                    <%=toFixed(addOnObject["IGST"])%>
                                                <%}else{%>
                                                    <span>-</span>
                                                <%}%>
                                            </td>
                                            <td class="textCenter">
                                                <%if(addOnObject["discount"]){%>
                                                    <%=toFixed(addOnObject["discount"])%>
                                                <%}else{%>
                                                    <span>-</span>
                                                <%}%>
                                            </td>
                                            <td>
                                                <%var amt = jsonLd.referencesOrder.orderedItem[i].orderQuantity * jsonLd.referencesOrder.orderedItem[i].orderedItem.offers.price%>
                                                <%=numberWithCommas(amt,2)%>
                                            </td> 
                                        </tr>
                                        <% } %>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    <%}%>
                    <div class="mt_1" style="width:100%">
                        <div class="ant-row">
                            <div class="ant-col-md-12 ant-col-xs-0"></div>
                            <div class="ant-col-md-12 ant-col-xs-24">
                                <div class="total-table mt_1 floatRight">
                                    <%var data = getTotalSummary()%>
                                    <%var totalSummary = JSON.parse(data).totalSummary%>
                                    <table>
                                        <tr>
                                            <td class="total-table__left">Sub Total</td>
                                            <td class="total-table__right"><%=getCurrency(totalSummary.subTotal, docInfo.currency)%></td>
                                        </tr>
                                        <tr>
                                           <td class="total-table__left">Discount (%) </td>
                                            <td class="total-table__right"><%=totalSummary.globalDiscount%></td>
                                        </tr>
                                        <tr>
                                        <td class="total-table__left">Total Tax </td>
                                            <td class="total-table__right"><%=getCurrency(totalSummary.totalTax, docInfo.currency)%></td>
                                        </tr>
                                        <tr>
                                            <td class="total-table__left">Discount on Items</td>
                                            <td class="total-table__right"><%=getCurrency(totalSummary.totalDiscount, docInfo.currency)%></td>
                                        </tr>
                                        <tr>
                                            <td class="total-table__left">Discount on Receipt</td>
                                            <td class="total-table__right"><%=getCurrency(totalSummary.globalDiscountValue, docInfo.currency)%></td>
                                        </tr>
                                        <tr>
                                            <td class="total-table__left">Total Discount</td>
                                            <td class="total-table__right"><%=getCurrency(totalSummary.totalDiscount + totalSummary.globalDiscountValue, docInfo.currency)%></td>
                                        </tr>
                                        <tr>
                                            <td class="total-table__left">Grand Total</td>
                                            <td class="total-table__right"><%=getCurrency(jsonLd.totalPaymentDue.price, docInfo.currency)%></td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="ml_1">
                        Amount Chargable: 
                            <span>
                                <h5 style="display: inline-block;"><%=getCurrency(docInfo.amountDue,docInfo.currency)%> </h5>
                            </span>
                        </div>
                        <div class="ml_1">Amount Chargable (in words): 
                            <span class="amtChargeColor">
                            <h5 style="display: inline-block;"><%=docInfo.amountDueInWords%></h5>
                            </span>
                        </div>
                    </div>
                    <%if(docInfo.additionalProperties && Object.keys(docInfo.additionalProperties).length>2){%>
                        <a class="ml_1" href="javascript:linkClicked('showMoreAdditionalFields')">View More Info</a>
                    <%}%>

                    <%# attachments%>
                    <div class="ant-row" style="width:100%">
                        <div class="ant-col-md-24">
                            <div class="ml_1 mb_1">
                                <%if(docInfo.attachments && docInfo.attachments.length !== 0){%>
                                    <%if(docInfo.attachments.length> 0 && docInfo.attachments.length>1){%>
                                        <span><a href="javascript:linkClicked('showFileAttachments')"><%=docInfo.attachments.length%> Files Attached</a></span>
                                        <span class="attachmentDividerColor">|</span>
                                    <%}else{%>
                                        <span><a href="javascript:linkClicked('showFileAttachments')"><%=docInfo.attachments.length%> File Attached</a></span>
                                        <span class="attachmentDividerColor">|</span>
                                    <%}%>
                                <%}%>
                                <%var subType = jsonLd["@subType"]%>
                                <%var attachedText = getAttachedText(jsonLd.status,subType)%>
                                <% var data = JSON.stringify({attachedText})%>
                                <%if(docInfo.noOfDocuments || docInfo.noOfDocuments !== 0 || docInfo.noOfDocuments>0 || Number(jsonLd.status)>=8){%>
                                   <%if(docInfo.noOfDocuments && attachedText){%>
                                        <a href="javascript:linkClicked('showAttachedDocuments',<%=data%>)">
                                            <span><%=docInfo.noOfDocuments%></span>&nbsp;
                                            <span><%=attachedText+'(s)'%></span>&nbsp;
                                            <span>attached</span>
                                            <span class="attachmentDividerColor">|</span>
                                        </a>
                                    <%}%>
                                <%}%>
                                <%if(docInfo.subTypeDocsAttached){%>
                                    <%for(let subType in docInfo.subTypeDocsAttached){%>
                                        <%var attachedSubDocs = docInfo.subTypeDocsAttached[subType]%>
                                        <%var attachedText = getAttachedText(attachedSubDocs[0].status,subType)%>
                                        <% var data = JSON.stringify({attachedText, subType})%>
                                        <a href="javascript:linkClicked('showAttachedDocuments',<%=data%>)">
                                            <span><%=attachedSubDocs.length%></span>&nbsp;
                                            <span><%=attachedText+'(s)'%></span>&nbsp;
                                            <span>attached</span>
                                            <span class="attachmentDividerColor">|</span>
                                        </a>                                        
                                    <%}%>
                                <%}%>

                                <%var partPurchaseOrder = jsonLd["partPurchaseOrder"]%>
                                <%if(partPurchaseOrder && partPurchaseOrder.length > 0){%>
                                    <% var data = JSON.stringify({attachedText: "Part PO"}) %>
                                    <a href="javascript:linkClicked('showAttachedDocuments', <%=data%>)">
                                        <span><%=partPurchaseOrder.length%></span>&nbsp;
                                        <span>Part PO(s) attached</span>&nbsp;
                                        <span class="attachmentDividerColor">|</span>
                                    </a>
                                <%}%>
                            </div>
                            <%if(docInfo.typeOfDocument !== "Dispute"){%>
                                <%if(jsonLd[jsonLd.status+'_note']){%>
                                    <div>
                                        <label className="label termsColor" id="cnote">Notes:</label>
                                        <p><%=jsonLd[jsonLd.status+'_note']%></p>
                                    </div>
                                <%}%>
                            <%}%>                        
                        </div>
                        
                    </div>               
                  
                    <div class="ml_1 mb_1">
                        <%if(docInfo.receiptMode === 'default'){%>
                            <a href="javascript:toggleHSNTable()" id="HSNTableLabel">Hide HSN Table</a>
                        <%}else{%>
                            <a href="javascript:toggleHSNTable()" id="HSNTableLabel">Show HSN Table</a>
                        <%}%>
                       
                    </div>
                  
                    <div class="ant-row mb_2 ml_1" style="width:100%">
                        
                        <div class="ant-col ant-col-md-0 ant-col-lg-4 ant-col-xl-4">
                            <%if(jsonLd.description){%>
                                <div>
                                    <label class="label termsColor" id="cnote">Terms:</label>
                                    <p><%=jsonLd.description%></p>
                                </div>
                            <%}%>
                            <%if(jsonLd.disambiguatingDescription){%>
                                <div>
                                    <label class="label termsColor" id="cnote">Note:</label>
                                    <p><%=jsonLd.disambiguatingDescription%></p>
                                </div>
                            <%}%>
                        </div>
                        <div class="ant-col ant-col-md-24 ant-col-lg-20 ant-col-xl-20" >
                            <%if(docInfo.receiptMode === 'default'){%>
                                <div id="HSNTable">
                            <%}else{%>
                                <div id="HSNTable" style="display:none">
                            <%}%>
                            <div class="ant-table-wrapper horizontalOverflow"> 
                                <div class="ant-table ant-table-small ant-table-bordered">
                                    <div class="ant-table-content">   
                                        <table class="HSNTable ant-table-body">
                                                <thead class="ant-table-thead">
                                                    <tr class="ant-table-row">
                                                        <th rowspan="2">HSN Code</th>
                                                        <th rowspan="2">Taxable Value</th>
                                                        <th colspan="2">Central Tax</th>
                                                        <th colspan="2">State Tax</th>
                                                        <th colspan="2">Other Tax</th>
                                                        <th rowspan="2">Total Tax Amount</th>
                                                    </tr>
                                                    <tr class="ant-table-row">
                                                        <th scope="col">Rate</th>
                                                        <th scope="col">Amount</th>
                                                        <th scope="col">Rate</th>
                                                        <th scope="col">Amount</th>
                                                        <th scope="col">Rate</th>
                                                        <th scope="col">Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody class="ant-table-tbody">
                                                <%var data = getTotalSummary()%>
                                                <%var taxTableData = JSON.parse(data).taxData%>
                                                    <%if(taxTableData){%>
                                                        <%for(let i in taxTableData){%>
                                                            <tr>
                                                                <td class="textCenter">
                                                                <%if(taxTableData[i].productId){%>
                                                                    <%= taxTableData[i].productId%>
                                                                <%}else{%>
                                                                    <span>-</span>
                                                                <%}%>
                                                                </td>
                                                                <td><%=numberWithCommas(taxTableData[i].taxableValue)%></td>
                                                                <td class="textCenter"><%=taxTableData[i].cgstRate%></td>
                                                                <td><%=numberWithCommas(taxTableData[i].cgstAmount)%></td>
                                                                <td class="textCenter"><%=taxTableData[i].sgstRate%></td>
                                                                <td><%=numberWithCommas(taxTableData[i].sgstAmount)%></td>
                                                                <td class="textCenter"><%=taxTableData[i].igstRate%></td>
                                                                <td><%=numberWithCommas(taxTableData[i].igstAmount)%></td>
                                                                <td><%=numberWithCommas(taxTableData[i].totalTax)%></td>
                                                            </tr>
                                                        <%}%>
                                                    <%}%>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt_1">Tax Amount (in words): <span class="amtChargeColor"><h5 style="display: inline-block;"><%=docInfo.taxAmountInWords%></h5></span></div>
                            
                            </div>
                            <br />
                            <br />
                            <br />
                        </div>
                    </div>


                </div>
          
            </div>
            <%
                function getTotalSummary(){
                    let items = jsonLd.referencesOrder.orderedItem;
                    let globalDiscount = jsonLd.referencesOrder.discount ? Number(jsonLd.referencesOrder.discount) : 0
                    let subTotal = 0, totalTax = 0, itemDiscount = 0, receiptDiscount = 0, totalDiscount = 0, taxData = [];
                    let sgstAmount = 0, sgstRate = 0, cgstRate = 0, cgstAmount = 0, igstRate = 0, igstAmount = 0, globalDiscountValue = 0;
                    for (let index = 0; index < items.length; index++) {
                        const currentItem = items[index];
                        let amt = Number(currentItem.orderQuantity) * Number(currentItem.orderedItem.offers.price)
                        subTotal += amt;
                        let taxPercent = 0, discountPercent = 0;
                        for (let tIndex in currentItem.orderedItem.offers.addOn) {
                            if (currentItem.orderedItem.offers.addOn[tIndex].name !== "discount") {
                                taxPercent += Number(currentItem.orderedItem.offers.addOn[tIndex].price)
                            }
                            if (currentItem.orderedItem.offers.addOn[tIndex].name === "discount") {
                                discountPercent += Number(currentItem.orderedItem.offers.addOn[tIndex].price)
                            }
                            if (currentItem.orderedItem.offers.addOn[tIndex].name === "SGST") {
                                sgstRate = Number(currentItem.orderedItem.offers.addOn[tIndex].price)
                                sgstAmount = amt * sgstRate / 100
                            }
                            if (currentItem.orderedItem.offers.addOn[tIndex].name === "CGST") {
                                cgstRate = Number(currentItem.orderedItem.offers.addOn[tIndex].price)
                                cgstAmount = amt * cgstRate / 100
                            }
                            if (currentItem.orderedItem.offers.addOn[tIndex].name === "IGST") {
                                igstRate = Number(currentItem.orderedItem.offers.addOn[tIndex].price)
                                igstAmount = amt * igstRate / 100
                            }
                        }
                        taxData.push({
                            productId: currentItem.orderedItem.productId,
                            taxableValue: amt,
                            sgstRate,
                            sgstAmount,
                            cgstRate,
                            cgstAmount,
                            igstRate,
                            igstAmount,
                            totalTax: amt * taxPercent / 100,
                            isTotal: false
                        })
                        totalTax += amt * taxPercent / 100
                        totalDiscount += amt * discountPercent / 100;
                    }
                    globalDiscountValue = globalDiscount * 0.01 * (subTotal - totalDiscount)
                    let totalsgstAmt = 0, totalcgstAmt = 0, totaligstAmt = 0;
                    for (let index in taxData) {
                        totalsgstAmt += taxData[index].sgstAmount
                        totalcgstAmt += taxData[index].cgstAmount
                        totaligstAmt += taxData[index].igstAmount
                    }
                    taxData.push({
                        productId: "Total",
                        taxableValue: totalTax,
                        sgstRate: "",
                        sgstAmount: totalsgstAmt,
                        cgstRate: "",
                        cgstAmount: totalcgstAmt,
                        igstRate: "",
                        igstAmount: totaligstAmt,
                        totalTax: totalTax,
                        isTotal: true
                    })
                    let totalSummary = {
                        subTotal,
                        globalDiscount,
                        globalDiscountValue,
                        totalTax,
                        itemDiscount,
                        receiptDiscount,
                        totalDiscount
                    }
                    return JSON.stringify({totalSummary,taxData});
                }

                function trimString(str, length){
                    return str.substring(0,length)+'...'
                }
                function getCurrency(amount, type, precision = 2) {
                    if (!amount || isNaN(amount)) {
                    amount = 0;
                    }
                    amount = Number(amount);
                    let negativeSign = amount < 0 ? "- " : "";
                    amount = Math.abs(amount);
                    amount = amount.toFixed(precision);
                    if (type && type !== null && type !== undefined) {
                        let symbol = checkCurrencyType(type);
                        amount = numberWithCommas(amount, precision)
                        let amountValue = symbol + negativeSign + amount;     
                        return amountValue;
                    }
                    // let currencyType = ls.get("Currency");
                    let currencyType = "";
                
                    if (currencyType === "" ||currencyType === undefined ||currencyType === null) {
                        amount = numberWithCommas(amount, precision)
                        return "\u20B9 " + negativeSign + amount;
                    }
                    let symbol = checkCurrencyType(currencyType);
                    amount = numberWithCommas(amount, precision)
                    return symbol + negativeSign + amount;
                }

                function checkCurrencyType(currencyType) {
                    let searchResult = search(currencyType);
                    if (!currencyType || !searchResult || !searchResult[0].currency || !searchResult[0].currency.currencySymbol) {
                      return '';
                    }
                    return searchResult[0].currency.currencySymbol;
                }

                function numberWithCommas(text, precision = 2) {
                    let number = Number(text)
                    if (isNaN(number) || number === undefined) {
                      return 0.00
                    }
                    number = number.toFixed(precision)
                    let fragments = number.split('.');
                    return fragments[0].toString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, ",") + '.' + fragments[1];
                }

                function toFixed(text,precision = 2){
                    let number = Number(text)
                    if (isNaN(number) || number === undefined) {
                        return 0.00
                      }
                    number = number.toFixed(precision)  
                    return number;
                }
                

                function search(txt) {
                    txt = (txt) ? txt.toUpperCase().trim() : null;
                    let results = [];
                
                    if (countries) {
                        countries.forEach(function (value, i) {
                
                            for (var j in value) {
                                if (value[j] == txt) {
                                    results.push(value);
                                    break;
                                }
                
                                var obj_2 = value[j];
                                if (obj_2.constructor === Object) {
                                    for (var k in obj_2) {
                                        if (obj_2[k] == txt) {
                                            results.push(value);
                                            break;
                                        }
                                    }
                                }
                            }
                        });
                    }
                
                    return results;
                }

                function getAdditionalPropertyAsObject(item) {
                    let additionalObject = {}
                    let additionalColumns = jsonLd.referencesOrder.additionalColumns
                    additionalColumns = JSON.parse(additionalColumns)
                    for(let i in additionalColumns){
                        additionalObject[additionalColumns[i]] = "---"
                    }
                    let properties = []
                    properties = Object.entries(item.orderedItem.additionalProperties)
                    for(let index in properties){
                        let key = properties[index][0]
                        let value = properties[index][1]
                        additionalObject[key] = value
                    }
                    return additionalObject;
                }

                function getAddOnAsObject(addOnArray) {
                    let addOnObject = {
                        SGST: 0,
                        CGST: 0,
                        IGST: 0,
                        discount: 0
                    }
                    for(let i in addOnArray) {
                        addOnObject[addOnArray[i].name] = addOnArray[i].price || 0;
                    }
                    return addOnObject;
                }
            %>`
export let defaultJsonLd = {
    "contract": {
        "allowExceedingFields": "0",
        "shareCatalogue": "0",
        "paymentTerms": "0",
        "alignedInfo": "0",
        "@id": "0x6a55f8354f4483968cc82fd300c96479994d792ced6772013975f57d5aa96bf8-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "isClosed": "false",
        "indexedInfo": "0x6a55f8354f4483968cc82fd300c96479994d792ced6772013975f57d5aa96bf8-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815_indexedInfo",
        "transactionSteps": [
            "0",
            "1"
        ],
        "status": "1",
        "step": "0",
        "childDocId": "0x1274e465e527897685ae79ef20ad790641ba52f475bd5123b30730021411e7ed-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "@context": "http://schema.org/",
        "transactionType": "2",
        "recordAdded": "1595610293074",
        "docOwner": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
        "createdByBuyer": "false",
        "contractNumber": "24/C2",
        "expiryDate": "2020-07-24T17:04:06.936Z",
        "subscribers": "0x17159E8fc34E303c5855af5737AbEaF0bA0E0044",
        "@type": "Invoice",
        "additionalProperty": "0",
        "additionalProperties": "{}",
        "minimumPaymentDue": {
            "@type": "PriceSpecification",
            "price": "1632680",
            "priceCurrency": "INR"
        },
        "totalPaymentDue": {
            "priceCurrency": "INR",
            "@type": "PriceSpecification",
            "price": "1632680"
        },
        "customer": {
            "@id": "0x93e401f392b93875a47e3fdac552c9d464ce4aacfeeaf65fc852d356955e2b37-0xDe3D2d87C02657A53fC379b4d45eeD9188266856",
            "indexedInfo": "0x93e401f392b93875a47e3fdac552c9d464ce4aacfeeaf65fc852d356955e2b37-0xDe3D2d87C02657A53fC379b4d45eeD9188266856_indexedInfo",
            "@context": "http://schema.org/",
            "status": "0",
            "owner": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
            "@type": "Person",
            "identifier": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
            "name": "Muthu",
            "telephone": "916778906789",
            "email": "xxxx@param.network",
            "publicKey": "79d2136d3b9814569ed796167a1351c38797477c8ea25117bd0ab0223291462c4ed8b4171981e9406c6bb433d3f7b97db9c60f3caf1a574e8f145c3cad255c4d",
            "internalId": "89127",
            "address": {
                "@type": "PostalAddress"
            },
            "contactPoint": {
                "telephone": "916778906789",
                "@type": "ContactPoint"
            },
            "jobTitle": {
                "@type": "DefinedTerm"
            },
            "worksFor": {
                "@type": "Organization"
            },
            "nationality": {
                "@type": "Country",
                "name": "IN"
            }
        },
        "provider": {
            "@type": "Person",
            "@context": "http://schema.org/",
            "identifier": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
            "name": "Prahlad Negi",
            "taxId": "TX21321",
            "email": "prahlad@param.network",
            "telephone": "918297398217",
            "publicKey": "38f0bfbb0ecb9772e7fe495728352a42f7f0d4f70288c067c6bafde9134a55b2dce82652791ef222272ed70ea5c69fbb371accc0f95fe532538eebbad964a66c",
            "address": {
                "@type": "PostalAddress"
            },
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "918297398217"
            },
            "jobTitle": {
                "@type": "DefinedTerm"
            },
            "nationality": {
                "@type": "Country",
                "name": "IN"
            },
            "worksFor": {
                "@type": "Organization",
                "name": "Param"
            }
        },
        "referencesOrder": {
            "discount": "2",
            "orderDate": "1595610246000",
            "@type": "Order",
            "additionalColumns": "[\"storage\",\"RAM\",\"Color\"]",
            "orderedItem": [
                {
                    "orderItemNumber": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                    "orderItemNumberLink": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                    "orderItemMapping": {
                        "@id": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                        "owner": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
                        "indexedInfo": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d_indexedInfo",
                        "@type": "Product",
                        "name": "Redmi Note 8 Pro",
                        "category": "goods",
                        "productId": "MI878",
                        "description": "Buy & Sell",
                        "itemType": "received item",
                        "primaryOwner": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
                        "additionalProperties": {
                            "Color": "White",
                            "RAM": "6GB",
                            "storage": "64GB"
                        },
                        "mappings": {
                            "@type": "Product",
                            "name": "Redmi Note 8 Pro",
                            "itemType": "goods",
                            "inventoryTxnType": "2",
                            "@id": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                            "owner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
                            "indexedInfo": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d_indexedInfo",
                            "mappings": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                            "@context": "http://schema.org",
                            "purpose": "3",
                            "catalogueTxnType": "2",
                            "isRelatedTo": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d_isRelatedTo",
                            "primaryOwner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
                            "inventory": "0x07a1f24595ea4fb54dd084e5b910c6089ae31a278bc84032bb3e8a4edcdfd8a2-0xf70451c209fD3f767984d2F0fb6f000aeD4b10D1",
                            "itemShareKey": "3BULOqR0Vm0smjHC7HZmIG9YNsCaLoWO5pP6sUGkuJDxJwE/w9peIo5ASXCPF/n8G2CkWGfLzrGlPFkLIKv0qwi6kT9N6eN8ljY2JHummTCfD8eJO3KAmm7qMJCWEGyFUfzqxC+xJGaikx2dj3ZlCttDvqIfFp8dyl45rOu/NyxfQ6BfxF1oBbijVn+xJLggGUMXLBA0WWyakrb8zftHeVjJVXiQd6GfLjtTsVAO/zMZ6JlXzi9wo5XOliryN2Gx4lH74OatPzqo9rUYgeSI3wwUyuuui/ssjq9271opaEvNxLDODzhGnOSaGXvVg7bmQAm08jqQKztFlyAsJXjk3VILFk7NfKJzi4YNo/ppCCxK2CbFi72KcR+ug/ZlmzghHcWNN0QsPF7+ccYrlVQa1kvfPL+QTgcdtmvAhTll51520MkJcznbRkMbRI5LrQ2GIuiNOsEyjwpTmu3G0d3F+fee3cqzvhfZAuNDvNIzFhejzWRAj2ueIuZYkuQY4RIo",
                            "aggregateRating": {
                                "@type": "AggregateRating"
                            },
                            "hasProductReturnPolicy": {
                                "@type": "ProductReturnPolicy"
                            },
                            "offers": {
                                "@type": "Offer",
                                "availability": "http://schema.org/InStock"
                            }
                        }
                    },
                    "status": "0",
                    "@type": "OrderItem",
                    "orderQuantity": "100",
                    "orderedItem": {
                        "@type": "Product",
                        "name": "Redmi Note 8 Pro",
                        "category": "goods",
                        "productId": "MI878",
                        "additionalProperties": {
                            "Color": "White",
                            "RAM": "6GB",
                            "storage": "64GB"
                        },
                        "offers": {
                            "price": "17000.00",
                            "@type": "Offer",
                            "addOn": [
                                {
                                    "@type": "Offer",
                                    "price": "0",
                                    "name": "SGST"
                                },
                                {
                                    "@type": "Offer",
                                    "price": "0",
                                    "name": "CGST"
                                },
                                {
                                    "@type": "Offer",
                                    "price": "0",
                                    "name": "IGST"
                                },
                                {
                                    "@type": "Offer",
                                    "price": "2",
                                    "name": "discount"
                                }
                            ]
                        }
                    }
                }
            ]
        },
        "transactions": [
            null
        ]
    },
    "purchaseOrder": {
        "shareCatalogue": "0",
        "paymentTerms": "2",
        "alignedInfo": "0",
        "grnManager": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
        "reverseMapping": "true",
        "@id": "0xd33815f5c84e6cedf72ccaa57444e3a205ab9b75ef34b7539a8eb732f0251bfc-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "step": "1",
        "parentDocId": "0x960b73e8c196df25faa1e875301659b98b7802156d6b4e82785149b88ee692ca-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "indexedInfo": "0xd33815f5c84e6cedf72ccaa57444e3a205ab9b75ef34b7539a8eb732f0251bfc-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815_indexedInfo",
        "transactionSteps": "3",
        "subscribers": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
        "@context": "http://schema.org/",
        "transactionType": "2",
        "allowExceedingFields": "0",
        "purchaseOrderNumber": "23/CON01/PO01",
        "@type": "Invoice",
        "additionalProperty": "1",
        "createdByBuyer": "true",
        "docOwner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
        "recordAdded": [
            "1595484848849",
            "1595484857633"
        ],
        "status": "3",
        "minimumPaymentDue": {
            "priceCurrency": "INR",
            "price": "100",
            "@type": "PriceSpecification"
        },
        "formData": "[]",
        "isClosed": "false",
        "totalPaymentDue": {
            "priceCurrency": "INR",
            "@type": "PriceSpecification",
            "price": "100"
        },
        "customer": {
            "@context": "http://schema.org/",
            "identifier": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
            "city": "BangalorE",
            "publicKey": "79d2136d3b9814569ed796167a1351c38797477c8ea25117bd0ab0223291462c4ed8b4171981e9406c6bb433d3f7b97db9c60f3caf1a574e8f145c3cad255c4d",
            "@type": "Person",
            "name": "MuthuKumar",
            "taxId": "90200",
            "email": "muthu@param.network",
            "telephone": "919788834378",
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "919788834378"
            },
            "worksFor": {
                "@type": "Organization",
                "name": "ParaM"
            },
            "jobTitle": {
                "@type": "DefinedTerm"
            },
            "nationality": {
                "@type": "Country",
                "name": "IN"
            },
            "address": {
                "@type": "PostalAddress",
                "addressLocality": "DomluR",
                "addressRegion": "KarnatagA",
                "streetAddress": "KR ColonY",
                "postalCode": "560071"
            }
        },
        "provider": {
            "@context": "http://schema.org/",
            "@type": "Person",
            "@id": "0x7845a0ea9e47be1adbff96f3f134dc5582a4304884dc81cbe058693be9120048-0xDe3D2d87C02657A53fC379b4d45eeD9188266856",
            "owner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
            "status": "0",
            "indexedInfo": "0x7845a0ea9e47be1adbff96f3f134dc5582a4304884dc81cbe058693be9120048-0xDe3D2d87C02657A53fC379b4d45eeD9188266856_indexedInfo",
            "identifier": "0x17159E8fc34E303c5855af5737AbEaF0bA0E0044",
            "name": "jitendra",
            "email": "jitendra@param.network",
            "internalId": "jiten",
            "telephone": "919899898989",
            "publicKey": "04e4eeafe5912a1dabfa5a06b3ae408684c3bd78e6b189f85a9fb1a0280364d49d0333e6485c2af5facdc4751a0b367ebeee5b0dd1fedf84c259092ee2012ad0",
            "jobTitle": {
                "@type": "DefinedTerm"
            },
            "worksFor": {
                "@type": "Organization"
            },
            "nationality": {
                "name": "IN",
                "@type": "Country"
            },
            "address": {
                "@type": "PostalAddress"
            },
            "contactPoint": {
                "telephone": "919899898989",
                "@type": "ContactPoint"
            }
        },
        "referencesOrder": {
            "discount": "0",
            "additionalColumns": "[]",
            "@type": "Order",
            "orderDate": "1595484811000",
            "orderedItem": [
                {
                    "orderItemNumber": "0x9c09b578ff451d3e975d352d84616fdd03eb1286b0f7a090710db0087f8dc6be-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                    "orderItemNumberLink": "0x9c09b578ff451d3e975d352d84616fdd03eb1286b0f7a090710db0087f8dc6be-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                    "orderItemMapping": {
                        "@id": "0x9c09b578ff451d3e975d352d84616fdd03eb1286b0f7a090710db0087f8dc6be-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                        "owner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
                        "indexedInfo": "0x9c09b578ff451d3e975d352d84616fdd03eb1286b0f7a090710db0087f8dc6be-0xa5f126CFF0835db28DecdDb833157B19f53e733d_indexedInfo",
                        "@context": "http://schema.org",
                        "subCategory": "Seasonal",
                        "category": "Fruit",
                        "purpose": "2",
                        "isRelatedTo": "0x9c09b578ff451d3e975d352d84616fdd03eb1286b0f7a090710db0087f8dc6be-0xa5f126CFF0835db28DecdDb833157B19f53e733d_isRelatedTo",
                        "productId": "ItemHSN1",
                        "primaryOwner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
                        "itemShareKey": "woCzZeLoQa0wzNwHpcEvLvZJ2MeI26qbOmI/IOkruQ7Ov7O32yB9Y2xCcrF/bndhUnVa/4Gtc5GLEC0B4xE+g8puHG9+isYfPtB62Yxo0cQn9j/XF6aHZK8VSPvKKOiDLovYzxxBkGo0br13DbqhYIsXfCypzzGeUvwoCD+bRmWPwpPFfJcAtzqpewdyF8E9akwp01vdfe0SvCo6tziTweTALvbKer7qmN3UFX5vTP5PZSHQL2OMSMI0kzclnQdX+9brSAeQWAdbiwLlEuaYMkmqq+btjz752bKop0tkj3jEGSO0YHWq/iULHwtcBSP7xHb3LVX3uTmpAg4bcXpDdAKj/qRmvugdJpBmfScQuO1ioy1wKrv79kSwcT+2rK8Uc+1AK60Pn78AB/vFTE3052bU6jhn68rbWpkyzz7AhYqydNQ665F5nSi4vtNQCIN4RsxEByWDbB3J1asDALBspgfzJxN+FlSUoTPG0i/eREMXwE1/Anl4u5Yl3t7H6j2+",
                        "@type": "Product",
                        "name": "Book",
                        "description": "Just a book",
                        "itemType": "goods",
                        "hasProductReturnPolicy": {
                            "@type": "ProductReturnPolicy"
                        },
                        "additionalItemFormDataType": [
                            {
                                "dataType": "input",
                                "defaultValue": "Big",
                                "isRequired": "true",
                                "key": "2",
                                "newAdded": "true",
                                "name": "size"
                            },
                            {
                                "isRequired": "true",
                                "defaultValue": "Blue",
                                "name": "color",
                                "newAdded": "true",
                                "dataType": "input",
                                "key": "1"
                            }
                        ],
                        "aggregateRating": {
                            "@type": "AggregateRating"
                        },
                        "offers": {
                            "@type": "Offer",
                            "availability": "http://schema.org/InStock"
                        },
                        "additionalProperties": {
                            "color": "Blue",
                            "size": "Big"
                        },
                        "internalId": {
                            "category": "goods",
                            "name": "Book",
                            "@type": "Product",
                            "productId": "ItemHSN1",
                            "@id": "ItemID1",
                            "owner": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
                            "indexedInfo": [
                                "ItemID1_indexedInfo",
                                "ItemID1_indexedInfo"
                            ],
                            "description": "Buy & Sell",
                            "itemType": "received item",
                            "primaryOwner": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
                            "additionalProperties": {
                                "size": "Big",
                                "color": "Blue"
                            }
                        },
                        "inventory": {
                            "@type": "Offer",
                            "volume": "KG",
                            "@id": "0x9b5862f305622434dc0869aae0c6cd64dbc9143a76bdba8375a068c77ad4b6fb-0xf70451c209fD3f767984d2F0fb6f000aeD4b10D1",
                            "inventoryShareKey": "woCzZeLoQa0wzNwHpcEvLvZJ2MeI26qbOmI/IOkruQ7Ov7O32yB9Y2xCcrF/bndhUnVa/4Gtc5GLEC0B4xE+g8puHG9+isYfPtB62Yxo0cQn9j/XF6aHZK8VSPvKKOiDLovYzxxBkGo0br13DbqhYIsXfCypzzGeUvwoCD+bRmWPwpPFfJcAtzqpewdyF8E9akwp01vdfe0SvCo6tziTweTALvbKer7qmN3UFX5vTP5PZSHQL2OMSMI0kzclnQdX+9brSAeQWAdbiwLlEuaYMkmqq+btjz752bKop0tkj3jEGSO0YHWq/iULHwtcBSP7xHb3LVX3uTmpAg4bcXpDdAKj/qRmvugdJpBmfScQuO1ioy1wKrv79kSwcT+2rK8Uc+1AK60Pn78AB/vFTE3052bU6jhn68rbWpkyzz7AhYqydNQ665F5nSi4vtNQCIN4RsxEByWDbB3J1asDALBspgfzJxN+FlSUoTPG0i/eREMXwE1/Anl4u5Yl3t7H6j2+",
                            "sku": "KG",
                            "price": "100",
                            "costPerItem": "20",
                            "productionDate": "22-07-2020",
                            "availableAt": {
                                "@type": "place"
                            },
                            "availableFrom": {
                                "@type": "place",
                                "address": "Bengaluru"
                            },
                            "inventoryLevel": {
                                "currentValue": "10",
                                "@type": "QuantitativeValue"
                            }
                        }
                    },
                    "orderQuantity": "1",
                    "@type": "OrderItem",
                    "orderedItem": {
                        "@type": "Product",
                        "additionalProperties": "0xd33815f5c84e6cedf72ccaa57444e3a205ab9b75ef34b7539a8eb732f0251bfc-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815_referencesOrder_orderedItem_0_orderedItem_additionalProperties",
                        "name": "Book",
                        "category": "goods",
                        "productId": "ItemHSN1",
                        "offers": {
                            "@type": "Offer",
                            "price": "100.00",
                            "addOn": [
                                {
                                    "@type": "Offer",
                                    "price": "0",
                                    "name": "SGST"
                                },
                                {
                                    "@type": "Offer",
                                    "price": "0",
                                    "name": "CGST"
                                },
                                {
                                    "@type": "Offer",
                                    "price": "0",
                                    "name": "IGST"
                                },
                                {
                                    "@type": "Offer",
                                    "price": "0",
                                    "name": "discount"
                                }
                            ]
                        }
                    }
                }
            ]
        },
        "transactions": [
            null
        ]
    },
    "invoice": {
        "transactionType": "2",
        "shareCatalogue": "0",
        "paymentTerms": "0",
        "invoiceNumber": "24/PO1/INV6",
        "alignedInfo": "0",
        "reverseMapping": "true",
        "@id": "0x314946cc66dbd17177475a1407440a1105ef25a3ea0bacb35873026820832025-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "step": "2",
        "parentDocId": "0x27eb85452d8baefcdeef74a39e81e49298353dd83e92e68dc8ca90ded1b5ed39-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "indexedInfo": "0x314946cc66dbd17177475a1407440a1105ef25a3ea0bacb35873026820832025-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815_indexedInfo",
        "transactionSteps": "5",
        "disputeInfo": "0",
        "@context": "http://schema.org/",
        "@type": "Invoice",
        "additionalProperty": "2",
        "identifier": "24/PO1/INV6",
        "allowExceedingFields": "0",
        "expectedDeliveryDate": "1595600929000",
        "createdByBuyer": "true",
        "docOwner": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
        "status": "5",
        "recordAdded": "1595600955143",
        "isClosed": "false",
        "formData": "[]",
        "totalPaymentDue": {
            "price": "69825",
            "@type": "PriceSpecification",
            "priceCurrency": "INR"
        },
        "minimumPaymentDue": {
            "priceCurrency": "INR",
            "@type": "PriceSpecification",
            "price": "69825"
        },
        "customer": {
            "@context": "http://schema.org/",
            "identifier": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
            "@type": "Person",
            "publicKey": "38f0bfbb0ecb9772e7fe495728352a42f7f0d4f70288c067c6bafde9134a55b2dce82652791ef222272ed70ea5c69fbb371accc0f95fe532538eebbad964a66c",
            "name": "Prahlad Negi",
            "address": {
                "@type": "PostalAddress"
            },
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "918297398217"
            },
            "taxId": "TX21321",
            "email": "prahlad@param.network",
            "telephone": "918297398217",
            "jobTitle": {
                "@type": "DefinedTerm"
            },
            "worksFor": {
                "@type": "Organization",
                "name": "Param"
            },
            "nationality": {
                "@type": "Country",
                "name": "IN"
            }
        },
        "provider": {
            "@id": "0x93e401f392b93875a47e3fdac552c9d464ce4aacfeeaf65fc852d356955e2b37-0xDe3D2d87C02657A53fC379b4d45eeD9188266856",
            "indexedInfo": "0x93e401f392b93875a47e3fdac552c9d464ce4aacfeeaf65fc852d356955e2b37-0xDe3D2d87C02657A53fC379b4d45eeD9188266856_indexedInfo",
            "@context": "http://schema.org/",
            "@type": "Person",
            "status": "0",
            "owner": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
            "identifier": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
            "name": "Muthu",
            "telephone": "916778906789",
            "email": "muthu@param.network",
            "publicKey": "79d2136d3b9814569ed796167a1351c38797477c8ea25117bd0ab0223291462c4ed8b4171981e9406c6bb433d3f7b97db9c60f3caf1a574e8f145c3cad255c4d",
            "internalId": "89127",
            "worksFor": {
                "@type": "Organization"
            },
            "nationality": {
                "@type": "Country",
                "name": "IN"
            },
            "address": {
                "@type": "PostalAddress"
            },
            "contactPoint": {
                "telephone": "916778906789",
                "@type": "ContactPoint"
            },
            "jobTitle": {
                "@type": "DefinedTerm"
            }
        },
        "referencesOrder": {
            "discount": "5",
            "orderDate": "1595600929000",
            "@type": "Order",
            "additionalColumns": "[\"storage\",\"RAM\",\"Color\"]",
            "orderedItem": [
                {
                    "orderItemNumber": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                    "orderItemNumberLink": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                    "buyerItemId": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                    "orderItemMapping": {
                        "@id": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                        "owner": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
                        "indexedInfo": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d_indexedInfo",
                        "@type": "Product",
                        "name": "Redmi Note 8 Pro",
                        "category": "goods",
                        "productId": "MI878",
                        "description": "Buy & Sell",
                        "itemType": "received item",
                        "primaryOwner": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
                        "additionalProperties": {
                            "Color": "White",
                            "RAM": "6GB",
                            "storage": "64GB"
                        },
                        "mappings": {
                            "@type": "Product",
                            "name": "Redmi Note 8 Pro",
                            "itemType": "goods",
                            "inventoryTxnType": "2",
                            "@id": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                            "owner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
                            "indexedInfo": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d_indexedInfo",
                            "mappings": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                            "isRelatedTo": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d_isRelatedTo",
                            "primaryOwner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
                            "inventory": "0x07a1f24595ea4fb54dd084e5b910c6089ae31a278bc84032bb3e8a4edcdfd8a2-0xf70451c209fD3f767984d2F0fb6f000aeD4b10D1",
                            "catalogueTxnType": "2",
                            "@context": "http://schema.org",
                            "purpose": "3",
                            "itemShareKey": "3BULOqR0Vm0smjHC7HZmIG9YNsCaLoWO5pP6sUGkuJDxJwE/w9peIo5ASXCPF/n8G2CkWGfLzrGlPFkLIKv0qwi6kT9N6eN8ljY2JHummTCfD8eJO3KAmm7qMJCWEGyFUfzqxC+xJGaikx2dj3ZlCttDvqIfFp8dyl45rOu/NyxfQ6BfxF1oBbijVn+xJLggGUMXLBA0WWyakrb8zftHeVjJVXiQd6GfLjtTsVAO/zMZ6JlXzi9wo5XOliryN2Gx4lH74OatPzqo9rUYgeSI3wwUyuuui/ssjq9271opaEvNxLDODzhGnOSaGXvVg7bmQAm08jqQKztFlyAsJXjk3VILFk7NfKJzi4YNo/ppCCxK2CbFi72KcR+ug/ZlmzghHcWNN0QsPF7+ccYrlVQa1kvfPL+QTgcdtmvAhTll51520MkJcznbRkMbRI5LrQ2GIuiNOsEyjwpTmu3G0d3F+fee3cqzvhfZAuNDvNIzFhejzWRAj2ueIuZYkuQY4RIo",
                            "aggregateRating": {
                                "@type": "AggregateRating"
                            },
                            "hasProductReturnPolicy": {
                                "@type": "ProductReturnPolicy"
                            },
                            "offers": {
                                "@type": "Offer",
                                "availability": "http://schema.org/InStock"
                            }
                        }
                    },
                    "orderQuantity": "5",
                    "status": "0",
                    "grnQuantities": "5",
                    "@type": "OrderItem",
                    "grnPrices": "17000",
                    "poQuantity": "500",
                    "poPrice": "17000.00",
                    "sellerItemId": {
                        "catalogueTxnType": "2",
                        "inventoryTxnType": "2",
                        "@id": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                        "primaryOwner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
                        "owner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
                        "indexedInfo": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d_indexedInfo",
                        "mappings": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                        "@context": "http://schema.org",
                        "itemType": "goods",
                        "purpose": "3",
                        "isRelatedTo": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d_isRelatedTo",
                        "@type": "Product",
                        "name": "Redmi Note 8 Pro",
                        "itemShareKey": "3BULOqR0Vm0smjHC7HZmIG9YNsCaLoWO5pP6sUGkuJDxJwE/w9peIo5ASXCPF/n8G2CkWGfLzrGlPFkLIKv0qwi6kT9N6eN8ljY2JHummTCfD8eJO3KAmm7qMJCWEGyFUfzqxC+xJGaikx2dj3ZlCttDvqIfFp8dyl45rOu/NyxfQ6BfxF1oBbijVn+xJLggGUMXLBA0WWyakrb8zftHeVjJVXiQd6GfLjtTsVAO/zMZ6JlXzi9wo5XOliryN2Gx4lH74OatPzqo9rUYgeSI3wwUyuuui/ssjq9271opaEvNxLDODzhGnOSaGXvVg7bmQAm08jqQKztFlyAsJXjk3VILFk7NfKJzi4YNo/ppCCxK2CbFi72KcR+ug/ZlmzghHcWNN0QsPF7+ccYrlVQa1kvfPL+QTgcdtmvAhTll51520MkJcznbRkMbRI5LrQ2GIuiNOsEyjwpTmu3G0d3F+fee3cqzvhfZAuNDvNIzFhejzWRAj2ueIuZYkuQY4RIo",
                        "inventory": "0x07a1f24595ea4fb54dd084e5b910c6089ae31a278bc84032bb3e8a4edcdfd8a2-0xf70451c209fD3f767984d2F0fb6f000aeD4b10D1",
                        "aggregateRating": {
                            "@type": "AggregateRating"
                        },
                        "hasProductReturnPolicy": {
                            "@type": "ProductReturnPolicy"
                        },
                        "offers": {
                            "@type": "Offer",
                            "availability": "http://schema.org/InStock"
                        }
                    },
                    "orderedItem": {
                        "@type": "Product",
                        "name": "Redmi Note 8 Pro",
                        "category": "goods",
                        "productId": "MI878",
                        "additionalProperties": {
                            "Color": "White",
                            "RAM": "6GB",
                            "storage": "64GB"
                        },
                        "offers": {
                            "@type": "Offer",
                            "price": "15000.00",
                            "addOn": [
                                {
                                    "@type": "Offer",
                                    "price": "0",
                                    "name": "SGST"
                                },
                                {
                                    "@type": "Offer",
                                    "price": "0",
                                    "name": "CGST"
                                },
                                {
                                    "@type": "Offer",
                                    "price": "2",
                                    "name": "discount"
                                },
                                {
                                    "@type": "Offer",
                                    "price": "0",
                                    "name": "IGST"
                                }
                            ]
                        }
                    }
                }
            ]
        },
        "transactions": [
            null
        ]
    },
    "payment": {
        "allowExceedingFields": "0",
        "shareCatalogue": "0",
        "paymentTerms": "2",
        "alignedInfo": "0",
        "@id": "0xb4af0a5abf51ff60e66bef6f4cc93f5e1f70831c97b475ba4ec59aa2dafbc57a-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "parentDocId": "0x7a81db174d6e5dbb93ffacfd74fc6898775b82b82084e651eef89d56400102ee-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "indexedInfo": "0xb4af0a5abf51ff60e66bef6f4cc93f5e1f70831c97b475ba4ec59aa2dafbc57a-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815_indexedInfo",
        "transactionSteps": "8",
        "@context": "http://schema.org/",
        "transactionType": "2",
        "docOwner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
        "paymentNumber": "24/INPO1/INV1/PAY1",
        "createdByBuyer": "true",
        "invoiceNumber": "24/INPO1/INV1",
        "status": "8",
        "formData": "[]",
        "isClosed": "false",
        "recordAdded": "1595597614886",
        "step": "3",
        "@type": "Invoice",
        "additionalProperty": "0",
        "totalPaymentDue": {
            "@type": "PriceSpecification",
            "priceCurrency": "INR",
            "price": "600000"
        },
        "minimumPaymentDue": {
            "priceCurrency": "INR",
            "price": "600000",
            "@type": "PriceSpecification"
        },
        "provider": {
            "@context": "http://schema.org/",
            "@type": "Person",
            "identifier": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
            "name": "Prahlad Negi",
            "taxId": "TX21321",
            "telephone": "918297398217",
            "email": "prahlad@param.network",
            "publicKey": "38f0bfbb0ecb9772e7fe495728352a42f7f0d4f70288c067c6bafde9134a55b2dce82652791ef222272ed70ea5c69fbb371accc0f95fe532538eebbad964a66c",
            "address": {
                "@type": "PostalAddress"
            },
            "contactPoint": {
                "telephone": "918297398217",
                "@type": "ContactPoint"
            },
            "nationality": {
                "name": "IN",
                "@type": "Country"
            },
            "jobTitle": {
                "@type": "DefinedTerm"
            },
            "worksFor": {
                "@type": "Organization",
                "name": "Param"
            }
        },
        "customer": {
            "@context": "http://schema.org/",
            "identifier": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
            "@type": "Person",
            "publicKey": "79d2136d3b9814569ed796167a1351c38797477c8ea25117bd0ab0223291462c4ed8b4171981e9406c6bb433d3f7b97db9c60f3caf1a574e8f145c3cad255c4d",
            "name": "MuthuKumar",
            "taxId": "90200",
            "email": "muthu@param.network",
            "telephone": "919788834378",
            "city": "BangalorE",
            "address": {
                "@type": "PostalAddress",
                "addressLocality": "DomluR",
                "addressRegion": "KarnatagA",
                "postalCode": "560071",
                "streetAddress": "KR ColonY"
            },
            "contactPoint": {
                "telephone": "919788834378",
                "@type": "ContactPoint"
            },
            "jobTitle": {
                "@type": "DefinedTerm"
            },
            "worksFor": {
                "@type": "Organization",
                "name": "ParaM"
            },
            "nationality": {
                "@type": "Country",
                "name": "IN"
            }
        },
        "referencesOrder": {
            "discount": "0",
            "@type": "Order",
            "orderDate": "1595597529000",
            "additionalColumns": "[\"storage\",\"RAM\",\"Color\"]",
            "orderedItem": [
                {
                    "orderItemNumber": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                    "orderItemNumberLink": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                    "sellerItemId": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                    "orderItemMapping": {
                        "@id": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                        "owner": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
                        "indexedInfo": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d_indexedInfo",
                        "@type": "Product",
                        "name": "Redmi Note 8 Pro",
                        "category": "goods",
                        "description": "Buy & Sell",
                        "itemType": "received item",
                        "primaryOwner": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
                        "productId": "MI878",
                        "additionalProperties": {
                            "Color": "White",
                            "RAM": "6GB",
                            "storage": "64GB"
                        },
                        "mappings": {
                            "@type": "Product",
                            "name": "Redmi Note 8 Pro",
                            "itemType": "goods",
                            "inventoryTxnType": "2",
                            "@id": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                            "owner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
                            "indexedInfo": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d_indexedInfo",
                            "mappings": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                            "@context": "http://schema.org",
                            "purpose": "3",
                            "isRelatedTo": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d_isRelatedTo",
                            "catalogueTxnType": "2",
                            "primaryOwner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
                            "itemShareKey": "3BULOqR0Vm0smjHC7HZmIG9YNsCaLoWO5pP6sUGkuJDxJwE/w9peIo5ASXCPF/n8G2CkWGfLzrGlPFkLIKv0qwi6kT9N6eN8ljY2JHummTCfD8eJO3KAmm7qMJCWEGyFUfzqxC+xJGaikx2dj3ZlCttDvqIfFp8dyl45rOu/NyxfQ6BfxF1oBbijVn+xJLggGUMXLBA0WWyakrb8zftHeVjJVXiQd6GfLjtTsVAO/zMZ6JlXzi9wo5XOliryN2Gx4lH74OatPzqo9rUYgeSI3wwUyuuui/ssjq9271opaEvNxLDODzhGnOSaGXvVg7bmQAm08jqQKztFlyAsJXjk3VILFk7NfKJzi4YNo/ppCCxK2CbFi72KcR+ug/ZlmzghHcWNN0QsPF7+ccYrlVQa1kvfPL+QTgcdtmvAhTll51520MkJcznbRkMbRI5LrQ2GIuiNOsEyjwpTmu3G0d3F+fee3cqzvhfZAuNDvNIzFhejzWRAj2ueIuZYkuQY4RIo",
                            "inventory": "0x07a1f24595ea4fb54dd084e5b910c6089ae31a278bc84032bb3e8a4edcdfd8a2-0xf70451c209fD3f767984d2F0fb6f000aeD4b10D1",
                            "hasProductReturnPolicy": {
                                "@type": "ProductReturnPolicy"
                            },
                            "aggregateRating": {
                                "@type": "AggregateRating"
                            },
                            "offers": {
                                "@type": "Offer",
                                "availability": "http://schema.org/InStock"
                            }
                        }
                    },
                    "@type": "OrderItem",
                    "orderQuantity": "40",
                    "buyerItemId": {
                        "purpose": "3",
                        "catalogueTxnType": "2",
                        "inventoryTxnType": "2",
                        "@id": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                        "primaryOwner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
                        "owner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
                        "indexedInfo": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d_indexedInfo",
                        "mappings": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                        "@context": "http://schema.org",
                        "itemType": "goods",
                        "@type": "Product",
                        "name": "Redmi Note 8 Pro",
                        "isRelatedTo": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d_isRelatedTo",
                        "itemShareKey": "3BULOqR0Vm0smjHC7HZmIG9YNsCaLoWO5pP6sUGkuJDxJwE/w9peIo5ASXCPF/n8G2CkWGfLzrGlPFkLIKv0qwi6kT9N6eN8ljY2JHummTCfD8eJO3KAmm7qMJCWEGyFUfzqxC+xJGaikx2dj3ZlCttDvqIfFp8dyl45rOu/NyxfQ6BfxF1oBbijVn+xJLggGUMXLBA0WWyakrb8zftHeVjJVXiQd6GfLjtTsVAO/zMZ6JlXzi9wo5XOliryN2Gx4lH74OatPzqo9rUYgeSI3wwUyuuui/ssjq9271opaEvNxLDODzhGnOSaGXvVg7bmQAm08jqQKztFlyAsJXjk3VILFk7NfKJzi4YNo/ppCCxK2CbFi72KcR+ug/ZlmzghHcWNN0QsPF7+ccYrlVQa1kvfPL+QTgcdtmvAhTll51520MkJcznbRkMbRI5LrQ2GIuiNOsEyjwpTmu3G0d3F+fee3cqzvhfZAuNDvNIzFhejzWRAj2ueIuZYkuQY4RIo",
                        "inventory": "0x07a1f24595ea4fb54dd084e5b910c6089ae31a278bc84032bb3e8a4edcdfd8a2-0xf70451c209fD3f767984d2F0fb6f000aeD4b10D1",
                        "aggregateRating": {
                            "@type": "AggregateRating"
                        },
                        "hasProductReturnPolicy": {
                            "@type": "ProductReturnPolicy"
                        },
                        "offers": {
                            "@type": "Offer",
                            "availability": "http://schema.org/InStock"
                        }
                    },
                    "orderedItem": {
                        "@type": "Product",
                        "name": "Redmi Note 8 Pro",
                        "category": "goods",
                        "productId": "MI878",
                        "additionalProperties": {
                            "RAM": "6GB",
                            "Color": "White",
                            "storage": "64GB"
                        },
                        "offers": {
                            "@type": "Offer",
                            "price": "17000.00",
                            "addOn": [
                                {
                                    "@type": "Offer",
                                    "price": "0",
                                    "name": "SGST"
                                },
                                {
                                    "@type": "Offer",
                                    "price": "0",
                                    "name": "CGST"
                                },
                                {
                                    "@type": "Offer",
                                    "price": "0",
                                    "name": "IGST"
                                },
                                {
                                    "@type": "Offer",
                                    "name": "discount",
                                    "price": "5"
                                }
                            ]
                        }
                    }
                }
            ]
        },
        "transactions": [
            null
        ]
    },
    "digitalReceipt": {
        "allowExceedingFields": "0",
        "shareCatalogue": "0",
        "paymentTerms": "2",
        "alignedInfo": "0",
        "@id": "0x33851f9072b9972e911261b5d213eac47fa714d00601db79bb89607f122b4cf2-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "isClosed": "false",
        "parentDocId": "0x7a81db174d6e5dbb93ffacfd74fc6898775b82b82084e651eef89d56400102ee-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "indexedInfo": "0x33851f9072b9972e911261b5d213eac47fa714d00601db79bb89607f122b4cf2-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815_indexedInfo",
        "status": "10",
        "@context": "http://schema.org/",
        "@type": "Invoice",
        "additionalProperty": "0",
        "transactionType": "2",
        "totalPaymentDue": {
            "@type": "PriceSpecification",
            "priceCurrency": "INR",
            "price": "13700"
        },
        "docOwner": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
        "paymentNumber": "24/INPO1/INV1/PAY1",
        "createdByBuyer": "false",
        "invoiceNumber": "24/INPO1/INV1",
        "recordAdded": "1595597600914",
        "transactionSteps": [
            "8",
            "10"
        ],
        "step": "4",
        "formData": "[]",
        "minimumPaymentDue": {
            "priceCurrency": "INR",
            "@type": "PriceSpecification",
            "price": "13700"
        },
        "provider": {
            "@context": "http://schema.org/",
            "@type": "Person",
            "identifier": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
            "publicKey": "38f0bfbb0ecb9772e7fe495728352a42f7f0d4f70288c067c6bafde9134a55b2dce82652791ef222272ed70ea5c69fbb371accc0f95fe532538eebbad964a66c",
            "name": "Prahlad Negi",
            "taxId": "TX21321",
            "email": "prahlad@param.network",
            "telephone": "918297398217",
            "address": {
                "@type": "PostalAddress"
            },
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "918297398217"
            },
            "jobTitle": {
                "@type": "DefinedTerm"
            },
            "nationality": {
                "@type": "Country",
                "name": "IN"
            },
            "worksFor": {
                "@type": "Organization",
                "name": "Param"
            }
        },
        "customer": {
            "@id": "0x93e401f392b93875a47e3fdac552c9d464ce4aacfeeaf65fc852d356955e2b37-0xDe3D2d87C02657A53fC379b4d45eeD9188266856",
            "indexedInfo": "0x93e401f392b93875a47e3fdac552c9d464ce4aacfeeaf65fc852d356955e2b37-0xDe3D2d87C02657A53fC379b4d45eeD9188266856_indexedInfo",
            "@context": "http://schema.org/",
            "status": "0",
            "owner": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
            "@type": "Person",
            "identifier": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
            "name": "Muthu",
            "telephone": "916778906789",
            "email": "muthu@param.network",
            "publicKey": "79d2136d3b9814569ed796167a1351c38797477c8ea25117bd0ab0223291462c4ed8b4171981e9406c6bb433d3f7b97db9c60f3caf1a574e8f145c3cad255c4d",
            "internalId": "89127",
            "jobTitle": {
                "@type": "DefinedTerm"
            },
            "worksFor": {
                "@type": "Organization"
            },
            "nationality": {
                "@type": "Country",
                "name": "IN"
            },
            "address": {
                "@type": "PostalAddress"
            },
            "contactPoint": {
                "telephone": "916778906789",
                "@type": "ContactPoint"
            }
        },
        "referencesOrder": {
            "discount": "0",
            "@type": "Order",
            "orderDate": "1595597530000",
            "additionalColumns": "[\"storage\",\"RAM\",\"Color\"]",
            "orderedItem": [
                {
                    "orderItemNumber": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                    "orderItemNumberLink": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                    "buyerItemId": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                    "orderItemMapping": {
                        "@id": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                        "owner": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
                        "indexedInfo": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d_indexedInfo",
                        "@type": "Product",
                        "name": "Redmi Note 8 Pro",
                        "category": "goods",
                        "productId": "MI878",
                        "description": "Buy & Sell",
                        "itemType": "received item",
                        "primaryOwner": "0x6d41eABE6edb843ad20df390d49a300537eC26c2",
                        "additionalProperties": {
                            "Color": "White",
                            "RAM": "6GB",
                            "storage": "64GB"
                        },
                        "mappings": {
                            "@type": "Product",
                            "name": "Redmi Note 8 Pro",
                            "itemType": "goods",
                            "inventoryTxnType": "2",
                            "@id": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                            "owner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
                            "indexedInfo": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d_indexedInfo",
                            "mappings": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                            "@context": "http://schema.org",
                            "purpose": "3",
                            "isRelatedTo": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d_isRelatedTo",
                            "catalogueTxnType": "2",
                            "primaryOwner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
                            "itemShareKey": "3BULOqR0Vm0smjHC7HZmIG9YNsCaLoWO5pP6sUGkuJDxJwE/w9peIo5ASXCPF/n8G2CkWGfLzrGlPFkLIKv0qwi6kT9N6eN8ljY2JHummTCfD8eJO3KAmm7qMJCWEGyFUfzqxC+xJGaikx2dj3ZlCttDvqIfFp8dyl45rOu/NyxfQ6BfxF1oBbijVn+xJLggGUMXLBA0WWyakrb8zftHeVjJVXiQd6GfLjtTsVAO/zMZ6JlXzi9wo5XOliryN2Gx4lH74OatPzqo9rUYgeSI3wwUyuuui/ssjq9271opaEvNxLDODzhGnOSaGXvVg7bmQAm08jqQKztFlyAsJXjk3VILFk7NfKJzi4YNo/ppCCxK2CbFi72KcR+ug/ZlmzghHcWNN0QsPF7+ccYrlVQa1kvfPL+QTgcdtmvAhTll51520MkJcznbRkMbRI5LrQ2GIuiNOsEyjwpTmu3G0d3F+fee3cqzvhfZAuNDvNIzFhejzWRAj2ueIuZYkuQY4RIo",
                            "inventory": "0x07a1f24595ea4fb54dd084e5b910c6089ae31a278bc84032bb3e8a4edcdfd8a2-0xf70451c209fD3f767984d2F0fb6f000aeD4b10D1",
                            "aggregateRating": {
                                "@type": "AggregateRating"
                            },
                            "hasProductReturnPolicy": {
                                "@type": "ProductReturnPolicy"
                            },
                            "offers": {
                                "@type": "Offer",
                                "availability": "http://schema.org/InStock"
                            }
                        }
                    },
                    "@type": "OrderItem",
                    "orderQuantity": "40",
                    "sellerItemId": {
                        "catalogueTxnType": "2",
                        "inventoryTxnType": "2",
                        "@id": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                        "primaryOwner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
                        "owner": "0x7d87d922bE8771A933548f4Facf797C764b06A3b",
                        "indexedInfo": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d_indexedInfo",
                        "mappings": "0x1a73b45b345e03c17e2e18882e37acd18370765f0785861d948aa232a198746e-0xa5f126CFF0835db28DecdDb833157B19f53e733d",
                        "@context": "http://schema.org",
                        "itemType": "goods",
                        "isRelatedTo": "0xaa9ba96ee145186616eec7f18b40ab261edc3b3f8d7ac77132cf7097459edd15-0xa5f126CFF0835db28DecdDb833157B19f53e733d_isRelatedTo",
                        "itemShareKey": "3BULOqR0Vm0smjHC7HZmIG9YNsCaLoWO5pP6sUGkuJDxJwE/w9peIo5ASXCPF/n8G2CkWGfLzrGlPFkLIKv0qwi6kT9N6eN8ljY2JHummTCfD8eJO3KAmm7qMJCWEGyFUfzqxC+xJGaikx2dj3ZlCttDvqIfFp8dyl45rOu/NyxfQ6BfxF1oBbijVn+xJLggGUMXLBA0WWyakrb8zftHeVjJVXiQd6GfLjtTsVAO/zMZ6JlXzi9wo5XOliryN2Gx4lH74OatPzqo9rUYgeSI3wwUyuuui/ssjq9271opaEvNxLDODzhGnOSaGXvVg7bmQAm08jqQKztFlyAsJXjk3VILFk7NfKJzi4YNo/ppCCxK2CbFi72KcR+ug/ZlmzghHcWNN0QsPF7+ccYrlVQa1kvfPL+QTgcdtmvAhTll51520MkJcznbRkMbRI5LrQ2GIuiNOsEyjwpTmu3G0d3F+fee3cqzvhfZAuNDvNIzFhejzWRAj2ueIuZYkuQY4RIo",
                        "inventory": "0x07a1f24595ea4fb54dd084e5b910c6089ae31a278bc84032bb3e8a4edcdfd8a2-0xf70451c209fD3f767984d2F0fb6f000aeD4b10D1",
                        "@type": "Product",
                        "name": "Redmi Note 8 Pro",
                        "purpose": "3",
                        "hasProductReturnPolicy": {
                            "@type": "ProductReturnPolicy"
                        },
                        "aggregateRating": {
                            "@type": "AggregateRating"
                        },
                        "offers": {
                            "@type": "Offer",
                            "availability": "http://schema.org/InStock"
                        }
                    },
                    "orderedItem": {
                        "category": "goods",
                        "name": "Redmi Note 8 Pro",
                        "@type": "Product",
                        "productId": "MI878",
                        "additionalProperties": {
                            "RAM": "6GB",
                            "storage": "64GB",
                            "Color": "White"
                        },
                        "offers": {
                            "@type": "Offer",
                            "price": "17000.00",
                            "addOn": [
                                {
                                    "@type": "Offer",
                                    "price": "0",
                                    "name": "SGST"
                                },
                                {
                                    "@type": "Offer",
                                    "price": "5",
                                    "name": "discount"
                                },
                                {
                                    "@type": "Offer",
                                    "price": "0",
                                    "name": "CGST"
                                },
                                {
                                    "@type": "Offer",
                                    "price": "0",
                                    "name": "IGST"
                                }
                            ]
                        }
                    }
                }
            ]
        },
        "transactions": [
            null
        ]
    }

}

export let defaultDocInfo = {
    "contract": {
        "docInternalId": "24/C2",
        "docId": "0x6a55f8354f4483968cc82fd300c96479994d792ced6772013975f57d5aa96bf8-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "invoiceNo": "0x6a55f8354f4483968cc82fd300c96479994d792ced6772013975f57d5aa96bf8-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "noOfDocuments": 1,
        "attachments": [],
        "taxAmountInWords": "Zero",
        "currency": "INR",
        "amountDue": "1632680",
        "amountDueInWords": "Sixteen Lakh Thirty Two Thousand Six Hundred Eighty Rupee Only",
        "amountDueDisplay": 1469412,
        "amountReceived": 163268,
        "noteValuesInfo": {
            "creditNote": 0,
            "debitNote": 0
        },
        "noteType": "",
        "fetchStatus": "Contract Accepted",
        "currentTab": "contract",
        "typeOfDocument": "Purchase Order",
        "expiryDate": "2020-07-24",
        "orderDate": "2020-07-24",
        "alignedInfoText": "",
        "additionalProperties": {},
        "subTypeDocsAttached": []
    },
    "purchaseOrder": {
        "docInternalId": "23/CON01/PO01",
        "docId": "0xd33815f5c84e6cedf72ccaa57444e3a205ab9b75ef34b7539a8eb732f0251bfc-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "invoiceNo": "0xd33815f5c84e6cedf72ccaa57444e3a205ab9b75ef34b7539a8eb732f0251bfc-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "noOfDocuments": 0,
        "attachments": [],
        "taxAmountInWords": "Zero",
        "currency": "INR",
        "amountDue": "100",
        "amountDueInWords": "Hundred Rupee Only",
        "amountDueDisplay": 100,
        "amountReceived": 0,
        "noteValuesInfo": {
            "creditNote": 0,
            "debitNote": 0
        },
        "noteType": "",
        "fetchStatus": "Purchase Order Created",
        "currentTab": "purchaseOrder",
        "typeOfDocument": "Invoice",
        "expiryDate": "2020-08-06",
        "orderDate": "2020-07-23",
        "parentDocId": "0x960b73e8c196df25faa1e875301659b98b7802156d6b4e82785149b88ee692ca",
        "alignedInfoText": "",
        "subTypeDocsAttached": []
    },
    "invoice": {
        "docInternalId": "24/PO1/INV6",
        "docId": "0x314946cc66dbd17177475a1407440a1105ef25a3ea0bacb35873026820832025-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "invoiceNo": "0x314946cc66dbd17177475a1407440a1105ef25a3ea0bacb35873026820832025-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "noOfDocuments": 0,
        "attachments": [],
        "taxAmountInWords": "Zero",
        "currency": "INR",
        "amountDue": "69825",
        "amountDueInWords": "Sixty Nine Thousand Eight Hundred Twenty Five Rupee Only",
        "amountDueDisplay": 69825,
        "amountReceived": 0,
        "noteValuesInfo": {
            "creditNote": 0,
            "debitNote": 0
        },
        "noteType": "",
        "fetchStatus": "Invoice Generated",
        "currentTab": "invoice",
        "typeOfDocument": "Payment",
        "expiryDate": "2020-08-06",
        "orderDate": "2020-07-24",
        "parentDocId": "0x27eb85452d8baefcdeef74a39e81e49298353dd83e92e68dc8ca90ded1b5ed39",
        "alignedInfoText": "",
        "subTypeDocsAttached": []
    },
    "payment": {
        "docInternalId": "24/INPO1/INV1/PAY1",
        "docId": "0xb4af0a5abf51ff60e66bef6f4cc93f5e1f70831c97b475ba4ec59aa2dafbc57a-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "invoiceNo": "0xb4af0a5abf51ff60e66bef6f4cc93f5e1f70831c97b475ba4ec59aa2dafbc57a-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "noOfDocuments": 0,
        "attachments": [],
        "taxAmountInWords": "Zero",
        "currency": "INR",
        "amountDue": "600000",
        "amountDueInWords": "Six Lakh Rupee Only",
        "amountDueDisplay": 600000,
        "amountReceived": 0,
        "noteValuesInfo": {
            "creditNote": 0,
            "debitNote": 0
        },
        "noteType": "",
        "fetchStatus": "Payment Successful",
        "currentTab": "payment",
        "typeOfDocument": "Contract",
        "expiryDate": "2020-08-06",
        "orderDate": "2020-07-24",
        "parentDocId": "0x7a81db174d6e5dbb93ffacfd74fc6898775b82b82084e651eef89d56400102ee",
        "alignedInfoText": "",
        "subTypeDocsAttached": []
    },
    "digitalReceipt": {
        "docInternalId": "24/INPO1/INV1/PAY1",
        "docId": "0x33851f9072b9972e911261b5d213eac47fa714d00601db79bb89607f122b4cf2-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "invoiceNo": "0x33851f9072b9972e911261b5d213eac47fa714d00601db79bb89607f122b4cf2-0x4A65da1Ce71BD34864Db6F8eB5389Cf6a03D2815",
        "noOfDocuments": 0,
        "attachments": [],
        "taxAmountInWords": "Zero",
        "currency": "INR",
        "amountDue": "13700",
        "amountDueInWords": "Thirteen Thousand Seven Hundred Rupee Only",
        "amountDueDisplay": 13700,
        "amountReceived": 0,
        "noteValuesInfo": {
            "creditNote": 0,
            "debitNote": 0
        },
        "noteType": "",
        "fetchStatus": "Digital Receipt",
        "currentTab": "payment",
        "typeOfDocument": "Contract",
        "expiryDate": "2020-08-06",
        "orderDate": "2020-07-24",
        "parentDocId": "0x7a81db174d6e5dbb93ffacfd74fc6898775b82b82084e651eef89d56400102ee",
        "alignedInfoText": "",
        "subTypeDocsAttached": []
    }
}